// import { Fragment, useEffect, useMemo, useRef, useState } from "react";
// import {
//   useAsyncDebounce,
//   useFilters,
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
// } from "react-table";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import moment from "moment";
// import { common_axios } from "../../../../App";
// import PersonIcon from "@mui/icons-material/Person";
// import Swal from "sweetalert2";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
// import {
//   Backdrop,
//   FormControl,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextareaAutosize,
//   CircularProgress,
//   InputAdornment,
// } from "@mui/material";
// import Loader from "../../../../components/Loader";
// import * as React from "react";
// import TextField from "@mui/material/TextField";
// import SearchIcon from "@mui/icons-material/Search";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { Link } from "react-router-dom";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import { actionid } from "../../../../redux/features/pageSlices";
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import dayjs from "dayjs";
// import PropTypes from "prop-types";
// import LinearProgress from "@mui/material/LinearProgress";
// import Box from "@mui/material/Box";
// // import "./Progress.css";
// // import TextField from "@mui/material/TextField";
// import ProgressLoader from "../DeliveryReports/ProgressLoader";
// // import TextField from "@mui/material/TextField";
// import { DateTimePicker } from "@mui/x-date-pickers";
// import { Tooltip } from "@mui/material";
// import DownloadData from "./DownloadData";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
// import InfoIcon from "@mui/icons-material/Info";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";

// function LinearProgressWithLabel(props) {
//   return (
//     <Box sx={{ display: "flex", alignItems: "center" }}>
//       <Box sx={{ width: "100%" }} className="mx-auto">
//         <LinearProgress
//           //   color="green"className="mt-1"
//           className="mt-1"
//           sx={{
//             "& .MuiLinearProgress-bar1Determinate": {
//               backgroundColor: props.colorr,
//             },
//           }}
//           variant="determinate"
//           {...props}
//         />
//       </Box>
//     </Box>
//   );
// }

// LinearProgressWithLabel.propTypes = {
//   /**
//    * The value of the progress indicator for the determinate and buffer variants.
//    * Value between 0 and 100.
//    */
//   value: PropTypes.number.isRequired,
//   color: PropTypes.number.isRequired,
// };

// export default function FortyEightHourReport() {
//   const [open, setOpen] = useState();
//   const [data, setData] = useState([]);
//   const [data1, setData1] = useState([]);
//   const [dataDownload, setDataDownload] = useState([]);
//   const [downloadLoader, setDownloadLoader] = useState(false);

//   const [data2, setData2] = useState([]);
//   // console.log("first", data2);
//   const [Status, setStatus] = useState({
//     approveType: "Completed",
//     resellerName: null,
//     type: null,
//     approveAssignedType: null,
//     hideShow: false,
//     pageNo: 0,
//     pageSize: 10,
//     selectorType: null,
//   });
//   const [FilterStatus, setFilterStatus] = useState({
//     filterpageNo: 0,
//     filterpageSize: 10,
//   });
//   // .....................................................Scroll Bar.................................................................//

//   const wrapper1Ref = useRef(null);
//   const wrapper2Ref = useRef(null);
//   const div1Ref = useRef(null);
//   const div2Ref = useRef(null);

//   const handleWrapper1Scroll = (e) => {
//     wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
//   };

//   const handleWrapper2Scroll = (e) => {
//     wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
//   };

//   const updateDivWidths = () => {
//     // if (div1Ref.current && div2Ref.current) {
//     //   div1Ref.current.style.width =
//     //     div2Ref.current.querySelector("table").offsetWidth + "px";
//     //   div2Ref.current.style.width =
//     //     div2Ref.current.querySelector("table").offsetWidth + "px";
//     // }
//   };

//   // ..................................................End Of Scroll Bar..............................................................//

//   const history = useHistory();
//   const dispatch = useDispatch();

//   const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
//   const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
//     useState(undefined);

//   const modelButtonReject = useRef(null);
//   const modelButtonApprove = useRef(null);

//   const approveUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setSelectedUserDetailApprove(cell.row.original);
//     await modelButtonApprove.current.click();
//   };
//   const [buttonDisable, setbuttonDisable] = useState(false);

//   const rejectUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setSelectedUserDetail(cell.row.original);
//     await modelButtonReject.current.click();
//   };
//   // ......................Download Modal Open//////////////////////////////////////////////

//   const [downloadModelOpen, setDownloadModel] = useState(undefined);
//   // console.log("first", downloadModelOpen);
//   const modelButtonDownload = useRef(null);
//   const DownloadAction = async (cell) => {
//     setDownloadModel(cell.row.original);
//     await modelButtonDownload.current.click();
//   };

//   // ..................................................................................//
//   const fetchUser = async () => {
//     try {
//       setOpen(true);
//       const res = common_axios(
//         `${
//           process.env.REACT_APP_COMMON_API_DASHBOARD_API
//         }/sms/campaign-report/v1/get/48-hour/count?Role=${
//           JSON.parse(localStorage.getItem("Sidebaritems")).name
//         }`
//       );
//       const res1 = common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/event-name`,
//         {
//           flag: Status?.approveType,
//           role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//         }
//       );

//       await Promise.all([res, res1]).then((values) => {
//         if (
//           values?.[0]?.data?.statusDescription?.statusCode == 200 &&
//           values?.[1]?.data?.statusDescription?.statusCode == 200
//         ) {
//           setData2({
//             count: values?.[0]?.data?.smsCampaignCounts?.[0],
//             eventNames: values?.[1]?.data?.eventName,
//           });

//           setOpen(false);
//         } else {
//           setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: values[0].data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       });
//     } catch (error) {
//       setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   // useEffect(async () => {
//   //   fetchUser();
//   // }, [Status.approveType]);

//   const fetchUserr = async () => {
//     if (Status?.resellerName || Status.type) {
//       try {
//         setOpen(true);

//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/find/by/campaign/name`,
//           {
//             flag: Status?.approveType,
//             eventName:
//               Status.resellerName == ("" && null) ? null : Status.resellerName,
//             pageNo: FilterStatus?.filterpageNo,
//             pageSize: FilterStatus?.filterpageSize,
//             category: Status?.type,
//             role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//           }
//         );
//         if (res.data?.statusDescription?.statusCode == 200) {
//           setData1(res.data?.playSmsOutgoingQueueData);
//           setData(res.data?.playSmsOutgoingQueueData?.content);
//           setOpen(false);
//         } else if (res.data?.statusDescription?.statusCode == 220) {
//           setData([]);
//           setOpen(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: res.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         } else {
//           setOpen(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: res.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } catch (error) {
//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } else {
//       setData([]);
//       try {
//         setOpen(true);

//         const res = common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/48-hour/campaign-data`,
//           {
//             flag: Status?.approveType,
//             pageNo: Status?.pageNo,
//             pageSize: Status?.pageSize,
//             role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//           }
//         );

//         let res1;

//         if (!data2?.count) {
//           res1 = common_axios(
//             `${
//               process.env.REACT_APP_COMMON_API_DASHBOARD_API
//             }/sms/campaign-report/v1/get/48-hour/count?Role=${
//               JSON.parse(localStorage.getItem("Sidebaritems")).name
//             }`
//           );
//         }

//         await Promise.allSettled(!data2?.count ? [res, res1] : [res]).then(
//           (results) => {
//             if (
//               results?.[0]?.value?.data?.statusDescription?.statusCode == 200
//             ) {
//               setData1(results?.[0]?.value?.data?.playSmsOutgoingQueueData);
//               setData(
//                 results?.[0]?.value?.data?.playSmsOutgoingQueueData?.content
//               );
//               for (
//                 let index = 0;
//                 index < results?.[0]?.value?.data?.playSmsOutgoingQueueData?.content?.length;
//                 index++
//               ) {
//                 results[0].value.data.playSmsOutgoingQueueData.content[index][`Show`] = true;
//                 // arr.push(obj);
//               }
//             }

//             if (
//               results?.[1]?.value?.data?.statusDescription?.statusCode == 200
//             ) {
//               setData2({
//                 count: results?.[1]?.value?.data?.smsCampaignCounts?.[0],
//                 eventNames: [],
//               });
//             }

//             if (
//               results?.[0]?.value?.data?.statusDescription?.statusCode == 220
//             ) {
//               setData([]);
//             }

//             if (
//               results?.[0]?.value?.data?.statusDescription?.statusCode != 200 &&
//               results?.[0]?.value?.data?.statusDescription?.statusCode != 220 &&
//               results?.[0]?.value?.data?.statusDescription?.statusCode
//             ) {
//               // await toast.error(results?.[1]?.value?.data?.statusDescription?.statusMessage, {
//               //   theme: "colored",
//               //   toastId: customId1,
//               // });
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: results?.[0]?.value?.data.statusDescription.statusMessage,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }

//             if (
//               results?.[1]?.value?.data?.statusDescription?.statusCode != 200 &&
//               results?.[1]?.value?.data?.statusDescription?.statusCode != 220 &&
//               results?.[1]?.value?.data?.statusDescription?.statusCode
//             ) {
//               // await toast.error(results?.[1]?.value?.data?.statusDescription?.statusMessage, {
//               //   theme: "colored",
//               //   toastId: customId1,
//               // });
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: results?.[1]?.value?.data.statusDescription.statusMessage,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }
//             setOpen(false);
//           }
//         );
//       } catch (error) {
//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     }
//   };

//   // ...................................................Refresh Button Api............................................................//

//   async function RefreshBtn(values) {
//     setData([]);
//     try {
//       setOpen(true);

//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/48-hour/campaign-data`,
//         {
//           flag: Status?.approveType,
//           role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//           pageNo: Status?.pageNo,
//           pageSize: Status?.pageSize,
//         }
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         setData1(res.data?.playSmsOutgoingQueueData);
//         setData(res.data?.playSmsOutgoingQueueData?.content);
//         for (
//           let index = 0;
//           index < res?.data?.playSmsOutgoingQueueData?.content?.length;
//           index++
//         ) {
//           res.data.playSmsOutgoingQueueData.content[index][`Show`] = true;
//           // arr.push(obj);
//         }
//         setOpen(false);
//         setStatus({
//           ...Status,
//           resellerName: null,
//           type: null,
//           hideShow: false,
//           selectorType: null,
//         });
//       } else if (res.data?.statusDescription?.statusCode == 220) {
//         setData([]);
//         setOpen(false);
//         // await toast.error(res.data?.statusDescription?.statusMessage, {
//         //   theme: "colored",
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         // await toast.error(res.data?.statusDescription?.statusMessage, {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   // ..................................................................................................................................//

//   // ...................................................Refresh Button Api............................................................//

//   async function LoaderApi(values) {
//     // setData([])
//     try {
//       // setOpen(true);

//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/48-hour/campaign-data`,
//         {
//           flag: Status?.approveType,
//           role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//           pageNo: Status?.pageNo,
//           pageSize: Status?.pageSize,
//         }
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         setData1(res.data?.playSmsOutgoingQueueData);
//         setData(res.data?.playSmsOutgoingQueueData?.content);
//         setDownloadLoader(false);

//         // setOpen(false);
//       } else if (res.data?.statusDescription?.statusCode == 220) {
//         setData([]);
//         setOpen(false);
//         // await toast.error(res.data?.statusDescription?.statusMessage, {
//         //   theme: "colored",
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         setDownloadLoader(false);

//         // await toast.error(res.data?.statusDescription?.statusMessage, {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);

//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   // ...................................................................................................................................../

//   useEffect(() => {
//     if (
//       Status.selectorType == null &&
//       Status.resellerName == "" &&
//       Status.type == null
//     )
//       fetchUserr();
//   }, [Status.resellerName, Status.type, Status.selectorType]);

//   useEffect(() => {
//     setStatus({
//       ...Status,
//       resellerName: null,
//     });
//   }, [Status.approveType]);

//   const defaultColumn = useMemo(() => {
//     return {
//       Filter: ColumnFilter,
//     };
//   }, []);

//   const columns = useMemo(
//     () =>
//       JSON.parse(localStorage.getItem("Sidebaritems")).name ==
//         "ROLE_SUPER_ADMIN" && Status?.approveType == "Failed"
//         ? [
//             {
//               Header: "Id",
//               accessor: "id",
//               Cell: (cell) => {
//                 // console.log("cell--", cell.row.index);
//                 return (
//                   <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
//                 );
//               },
//             },
//             {
//               Header: "Campaign name",

//               accessor: "event_Name",
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <Link
//                       onClick={() => {
//                         localStorage.setItem(
//                           "dstQueCode",
//                           `${cell.row.original.queue_code},${cell.row.original.id}`
//                         );
//                       }}
//                       style={{
//                         textDecoration: "underline",
//                         fontWeight: "bolder",
//                       }}
//                       to={`/dashboard/48HourReport/All`}
//                     >
//                       {cell.row.original.event_Name}
//                     </Link>
//                     <div className="my-2 fw-bold" style={{ color: "#959595" }}>
//                       {`(${cell?.row?.original?.username})`}
//                     </div>
//                   </>
//                 );
//               },
//             },

//             {
//               Header: "Start Date Time",

//               accessor: "datetime_Entry", // accessor is the "key" in the data
//               // Cell: (cell) => {
//               //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
//               // },
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_Entry
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "End Date Time",

//               accessor: "datetime_End", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_End
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sender Id",

//               accessor: "sender_Id", // accessor is the "key" in the data
//             },
//             {
//               Header: "Total Sms",

//               accessor: "sms_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Sms Success",

//               accessor: "success_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.success_Count?.toLocaleString("en-US")}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sms Fail",

//               accessor: "fail_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Camp Type",

//               accessor: "sms_Type", // accessor is the "key" in the data

//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.sms_Type == "Promotional " ? (
//                       <div className="">P</div>
//                     ) : (
//                       <div className="">T</div>
//                     )}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Failed Reason",

//               accessor: "status", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.scheduled_Status == 8 ? (
//                       <div
//                         className=""
//                         // style={{ width: "71% !important" }}
//                       >
//                         {/* Message Pushed {"    "} */}
//                         {cell?.row?.original?.status}
//                       </div>
//                     ) : (
//                       <div
//                         className="badge bg-success activated_1"
//                         // style={{ width: "71% !important" }}
//                       >
//                         {/* {cell?.row?.original?.log} */}
//                       </div>
//                     )}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Message",
//               accessor: "message", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.message.length >= 60 ? (
//                       <div className="">
//                         <div className="showMoreTd">
//                           {cell.row.original?.[`Show`]
//                             ? cell.row.original.message?.slice(0, 60) + "..."
//                             : cell.row.original.message}
//                         </div>
//                         <button
//                           className="showMore"
//                           onClick={() => {
//                             // Showdata?.[`Show${cell.row.index}`];
      
//                             const dataaa = [...data];
      
//                             dataaa[cell.row.index][`Show`] =
//                               !cell.row.original?.[`Show`];
      
//                             setData(dataaa);
//                           }}
//                         >
//                           {cell.row.original?.[`Show`] ? "More" : "Less"}
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="showMoreTd">{cell.row.original.message}</div>
//                     )}
//                   </>
//                 );
//               },
//             },

//             {
//               Header: "Download",
//               Footer: "Download",
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.file_Status == false ||
//                     (downloadModelOpen?.id === cell?.row?.original?.id &&
//                       downloadLoader == true) ? (
//                       <>
//                         <Box
//                           sx={{ display: "block", width: "100px" }}
//                           className="mx-auto"
//                         >
//                           <CircularProgress
//                             style={{ width: "31px", height: "31px" }}
//                           />
//                         </Box>
//                       </>
//                     ) : cell?.row?.original?.file_Status == true ? (
//                       <>
//                         <div className="">
//                           <button
//                             className="btn color_1 px-2"
//                             type="button"
//                             id=""
//                             data-bs-toggle=""
//                             aria-expanded="false"
//                             onClick={() => {
//                               downloadFile(cell);
//                             }}
//                           >
//                             <FileDownloadIcon />
//                           </button>
//                         </div>
//                       </>
//                     ) : (
//                       <div className="">
//                         <button
//                           type="button"
//                           className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                           id="btn_Update"
//                           style={{ width: "auto" }}
//                           onClick={() => {
//                             DownloadAction(cell);
//                           }}
//                           // disabled={DownloadDisable}
//                         >
//                           {/* Download Request */}
//                           <DownloadingSharpIcon />
//                         </button>
//                       </div>
//                     )}
//                   </>
//                 );
//               },
//             },
//           ]
//         : JSON.parse(localStorage.getItem("Sidebaritems")).name ==
//             "ROLE_USER" && Status?.approveType == "Failed"
//         ? [
//             {
//               Header: "Id",
//               accessor: "id",
//               Cell: (cell) => {
//                 // console.log("cell--", cell.row.index);
//                 return (
//                   <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
//                 );
//               },
//             },
//             {
//               Header: "Event name",

//               accessor: "event_Name",
//               Cell: (cell) => {
//                 return (
//                   <Link
//                     onClick={() => {
//                       localStorage.setItem(
//                         "dstQueCode",
//                         `${cell.row.original.queue_code},${cell.row.original.id}`
//                       );
//                     }}
//                     style={{
//                       textDecoration: "underline",
//                       fontWeight: "bolder",
//                     }}
//                     to={`/dashboard/48HourReport/All`}
//                   >
//                     {cell.row.original.event_Name}
//                   </Link>
//                 );
//               },
//             },

//             {
//               Header: "Start Date Time",

//               accessor: "datetime_Entry", // accessor is the "key" in the data
//               // Cell: (cell) => {
//               //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
//               // },
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_Entry
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "End Date Time",

//               accessor: "datetime_End", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_End
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sender Id",

//               accessor: "sender_Id", // accessor is the "key" in the data
//             },
//             {
//               Header: "Total Sms",

//               accessor: "sms_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Sms Success",

//               accessor: "success_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.success_Count?.toLocaleString("en-US")}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sms Fail",

//               accessor: "fail_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Camp Type",

//               accessor: "sms_Type", // accessor is the "key" in the data

//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.sms_Type == "Promotional " ? (
//                       <div className="">P</div>
//                     ) : (
//                       <div className="">T</div>
//                     )}
//                   </>
//                 );
//               },
//             },

//             {
//               Header: "Message",
//               accessor: "message", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.message.length >= 60 ? (
//                       <div className="">
//                         <div className="showMoreTd">
//                           {cell.row.original?.[`Show`]
//                             ? cell.row.original.message?.slice(0, 60) + "..."
//                             : cell.row.original.message}
//                         </div>
//                         <button
//                           className="showMore"
//                           onClick={() => {
//                             // Showdata?.[`Show${cell.row.index}`];
      
//                             const dataaa = [...data];
      
//                             dataaa[cell.row.index][`Show`] =
//                               !cell.row.original?.[`Show`];
      
//                             setData(dataaa);
//                           }}
//                         >
//                           {cell.row.original?.[`Show`] ? "More" : "Less"}
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="showMoreTd">{cell.row.original.message}</div>
//                     )}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Action",
//               accessor: "action",
//               Cell: (cell) => (
//                 <div className="d-flex justify-content-center align-items-center">
//                   <div className="">
//                     <ul>
//                       <li>
//                         <button
//                           className="btn color_1 px-2"
//                           type="button"
//                           id=""
//                           data-bs-toggle=""
//                           aria-expanded="false"
//                           onClick={() => {
//                             rejectUserModal(cell);
//                           }}
//                         >
//                           <ScheduleIcon />
//                         </button>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               ),
//               disableFilters: true,
//             },
//             {
//               Header: "Download",
//               Footer: "Download",
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.file_Status == false ||
//                     (downloadModelOpen?.id === cell?.row?.original?.id &&
//                       downloadLoader == true) ? (
//                       <>
//                         <Box
//                           sx={{ display: "block", width: "100px" }}
//                           className="mx-auto"
//                         >
//                           <CircularProgress
//                             style={{ width: "31px", height: "31px" }}
//                           />
//                         </Box>
//                       </>
//                     ) : cell?.row?.original?.file_Status == true ? (
//                       <>
//                         <div className="">
//                           <button
//                             className="btn color_1 px-2"
//                             type="button"
//                             id=""
//                             data-bs-toggle=""
//                             aria-expanded="false"
//                             onClick={() => {
//                               downloadFile(cell);
//                             }}
//                           >
//                             <FileDownloadIcon />
//                           </button>
//                         </div>
//                       </>
//                     ) : (
//                       <div className="">
//                         <button
//                           type="button"
//                           className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                           id="btn_Update"
//                           style={{ width: "auto" }}
//                           onClick={() => {
//                             DownloadAction(cell);
//                           }}
//                           // disabled={DownloadDisable}
//                         >
//                           {/* Download Request */}
//                           <DownloadingSharpIcon />
//                         </button>
//                       </div>
//                     )}
//                   </>
//                 );
//               },
//             },
//           ]
//         : JSON.parse(localStorage.getItem("Sidebaritems")).name ==
//             "ROLE_SUPER_ADMIN" && Status?.approveType != "Failed"
//         ? [
//             {
//               Header: "Id",
//               accessor: "id",
//               Cell: (cell) => {
//                 // console.log("cell--", cell.row.index);
//                 return (
//                   <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
//                 );
//               },
//             },
//             {
//               Header: "Campaign name",

//               accessor: "event_Name",
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <Link
//                       onClick={() => {
//                         localStorage.setItem(
//                           "dstQueCode",
//                           `${cell.row.original.queue_code},${cell.row.original.id}`
//                         );
//                       }}
//                       style={{
//                         textDecoration: "underline",
//                         fontWeight: "bolder",
//                       }}
//                       to={`/dashboard/48HourReport/All`}
//                     >
//                       {cell.row.original.event_Name}
//                     </Link>
//                     <div className="my-2 fw-bold" style={{ color: "#959595" }}>
//                       {`(${cell?.row?.original?.username})`}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Start Date Time",

//               accessor: "datetime_Entry", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_Entry
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "End Date Time",

//               accessor: "datetime_End", // accessor is the "key" in the data
//               // Cell: (cell) => {
//               //   return <>{dateFormatter(cell.row.original.datetimeEntry)}</>;
//               // },
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_End
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sender Id",
//               accessor: "sender_Id", // accessor is the "key" in the data
//             },
//             {
//               Header: "Total Sms",

//               accessor: "sms_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Sms Success",

//               accessor: "success_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.success_Count?.toLocaleString("en-US")}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sms Fail",

//               accessor: "fail_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Camp Type",

//               accessor: "sms_Type", // accessor is the "key" in the data

//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.sms_Type == "Promotional " ? (
//                       <div className="">P</div>
//                     ) : (
//                       <div className="">T</div>
//                     )}
//                   </>
//                 );
//               },
//             },

//             // {
//             //   Header: "Download",
//             //   Footer: "Download",
//             //   // accessor: "downloadUrl",
//             //   Cell: (cell) => (
//             //     <div className="">
//             //       <button
//             //         className="btn color_1 px-2"
//             //         type="button"
//             //         id=""
//             //         data-bs-toggle=""
//             //         aria-expanded="false"
//             //         onClick={() => {
//             //           DownloadAction(cell);
//             //         }}
//             //       >
//             //         <FileDownloadIcon />
//             //       </button>
//             //     </div>
//             //   ),
//             // },
//             {
//               Header: "Message",
//               accessor: "message", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.message.length >= 60 ? (
//                       <div className="">
//                         <div className="showMoreTd">
//                           {cell.row.original?.[`Show`]
//                             ? cell.row.original.message?.slice(0, 60) + "..."
//                             : cell.row.original.message}
//                         </div>
//                         <button
//                           className="showMore"
//                           onClick={() => {
//                             // Showdata?.[`Show${cell.row.index}`];
      
//                             const dataaa = [...data];
      
//                             dataaa[cell.row.index][`Show`] =
//                               !cell.row.original?.[`Show`];
      
//                             setData(dataaa);
//                           }}
//                         >
//                           {cell.row.original?.[`Show`] ? "More" : "Less"}
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="showMoreTd">{cell.row.original.message}</div>
//                     )}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Download",
//               Footer: "Download",
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.file_Status == false ||
//                     (downloadModelOpen?.id === cell?.row?.original?.id &&
//                       downloadLoader == true) ? (
//                       <>
//                         <Box
//                           sx={{ display: "block", width: "100px" }}
//                           className="mx-auto"
//                         >
//                           <CircularProgress
//                             style={{ width: "31px", height: "31px" }}
//                           />
//                         </Box>
//                       </>
//                     ) : cell?.row?.original?.file_Status == true ? (
//                       <>
//                         <div className="">
//                           <button
//                             className="btn color_1 px-2"
//                             type="button"
//                             id=""
//                             data-bs-toggle=""
//                             aria-expanded="false"
//                             onClick={() => {
//                               downloadFile(cell);
//                             }}
//                           >
//                             <FileDownloadIcon />
//                           </button>
//                         </div>
//                       </>
//                     ) : (
//                       <div className="">
//                         <button
//                           type="button"
//                           className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                           id="btn_Update"
//                           style={{ width: "auto" }}
//                           onClick={() => {
//                             DownloadAction(cell);
//                           }}
//                           // disabled={DownloadDisable}
//                         >
//                           {/* Download Request */}
//                           <DownloadingSharpIcon />
//                         </button>
//                       </div>
//                     )}
//                   </>
//                 );
//               },
//             },
//           ]
//         : [
//             {
//               Header: "Id",
//               accessor: "id",
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
//                 );
//               },
//             },
//             {
//               Header: "Campaign name",

//               accessor: "event_Name",
//               Cell: (cell) => {
//                 return (
//                   <Link
//                     onClick={() => {
//                       localStorage.setItem(
//                         "dstQueCode",
//                         `${cell.row.original.queue_code},${cell.row.original.id}`
//                       );
//                     }}
//                     style={{
//                       textDecoration: "underline",
//                       fontWeight: "bolder",
//                     }}
//                     to={`/dashboard/48HourReport/All`}
//                   >
//                     {cell.row.original.event_Name}
//                   </Link>
//                 );
//               },
//             },

//             {
//               Header: "Start Date Time",

//               accessor: "datetime_Entry", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_Entry
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "End Date Time",

//               accessor: "datetime_End", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     <div>
//                       {cell?.row?.original?.datetime_End
//                         ?.split(" ")
//                         ?.map((dataaa) => {
//                           return (
//                             <>
//                               <span>{dataaa}</span>
//                               <br />
//                             </>
//                           );
//                         })}
//                     </div>
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sender Id",

//               accessor: "sender_Id", // accessor is the "key" in the data
//             },

//             {
//               Header: "Total Sms",

//               accessor: "sms_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Sms Success",

//               accessor: "success_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.success_Count?.toLocaleString("en-US")}
//                   </>
//                 );
//               },
//             },
//             {
//               Header: "Sms Fail",

//               accessor: "fail_Count", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
//                 );
//               },
//             },
//             {
//               Header: "Camp Type",

//               accessor: "sms_Type", // accessor is the "key" in the data

//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.sms_Type == "Promotional " ? (
//                       <div className="">P</div>
//                     ) : (
//                       <div className="">T</div>
//                     )}
//                   </>
//                 );
//               },
//             },
//             // {
//             //   Header: "Status",

//             //   accessor: "scheduled_Status",
//             //   Cell: (cell) => {
//             //     return (
//             //       <>
//             //         {cell.row.original.scheduled_Status == 6 ? (
//             //           <div className="badge bg-success activated_1">
//             //             Completed
//             //           </div>
//             //         ) : cell.row.original.scheduled_Status == 7 ? (
//             //           <div className="badge bg-warning activated_1">
//             //             All numbers are in Blacklist/DND
//             //           </div>
//             //         ) : cell.row.original.scheduled_Status == 8 ? (
//             //           <div className="badge bg-warning activated_1">Failed</div>
//             //         ) : (
//             //           <div className="badge bg-danger activated_1">Stopped</div>
//             //         )}
//             //       </>
//             //     );
//             //   },
//             // },

//             {
//               Header: "Message",
//               accessor: "message", // accessor is the "key" in the data
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.message.length >= 60 ? (
//                       <div className="">
//                         <div className="showMoreTd">
//                           {cell.row.original?.[`Show`]
//                             ? cell.row.original.message?.slice(0, 60) + "..."
//                             : cell.row.original.message}
//                         </div>
//                         <button
//                           className="showMore"
//                           onClick={() => {
//                             // Showdata?.[`Show${cell.row.index}`];
      
//                             const dataaa = [...data];
      
//                             dataaa[cell.row.index][`Show`] =
//                               !cell.row.original?.[`Show`];
      
//                             setData(dataaa);
//                           }}
//                         >
//                           {cell.row.original?.[`Show`] ? "More" : "Less"}
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="showMoreTd">{cell.row.original.message}</div>
//                     )}
//                   </>
//                 );
//               },
//             },

//             {
//               Header: "Download",
//               Footer: "Download",
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell?.row?.original?.file_Status == false ||
//                     (downloadModelOpen?.id === cell?.row?.original?.id &&
//                       downloadLoader == true) ? (
//                       <>
//                         <Box
//                           sx={{ display: "block", width: "100px" }}
//                           className="mx-auto"
//                         >
//                           <CircularProgress
//                             style={{ width: "31px", height: "31px" }}
//                           />
//                         </Box>
//                       </>
//                     ) : cell?.row?.original?.file_Status == true ? (
//                       <>
//                         <div className="">
//                           <button
//                             className="btn color_1 px-2"
//                             type="button"
//                             id=""
//                             data-bs-toggle=""
//                             aria-expanded="false"
//                             onClick={() => {
//                               downloadFile(cell);
//                             }}
//                           >
//                             <FileDownloadIcon />
//                           </button>
//                         </div>
//                       </>
//                     ) : (
//                       <div className="">
//                         <button
//                           type="button"
//                           className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                           id="btn_Update"
//                           style={{ width: "auto" }}
//                           onClick={() => {
//                             DownloadAction(cell);
//                           }}
//                           // disabled={DownloadDisable}
//                         >
//                           {/* Download Request */}
//                           <DownloadingSharpIcon />
//                         </button>
//                       </div>
//                     )}
//                   </>
//                 );
//               },
//             },
//           ],

//     [
//       JSON.parse(localStorage.getItem("Sidebaritems")).name ==
//         "ROLE_SUPER_ADMIN",
//       Status?.approveType,
//       downloadLoader,
//       Status,
//       data,
//     ]
//   );
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     // footerGroups,
//     rows,
//     page,
//     nextPage,
//     canNextPage,
//     previousPage,
//     canPreviousPage,
//     pageOptions,
//     gotoPage,
//     pageCount,
//     setPageSize,
//     prepareRow,
//     state,
//     setGlobalFilter,
//     selectedFlatRows,
//     setColumnOrder,
//     allColumns,
//     getToggleHideAllColumnsProps,
//   } = useTable(
//     {
//       columns,
//       data,
//       defaultColumn,
//       // initialState: { pageIndex: 1 }
//     },
//     useFilters,
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//     useRowSelect
//   );

//   const viewRefModal = useRef(null);

//   const { globalFilter } = state;

//   const deletUser = () => {
//     // console.log({ selectedFlatRows });
//   };
//   // ............................................................................................//
//   async function DownloadApi(cell) {
//     try {
//       window.location.href = `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/export/transactional/report/excel?queueCode=${cell?.row?.original?.queue_code}`;
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }

//   // .........................................Schedule Api........................//
//   const ScheduleApi = async () => {
//     try {
//       setOpen(true);
//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/re-scheduled/failed/campaign`,
//         {
//           queueCode: selectedUserDetail?.queue_code,

//           resheduledDateTime: moment(
//             selectedUserDetail?.datetime_Scheduled
//           )?.format("YYYY-MM-DD HH:mm:ss"),
//         }
//       );
//       // console.log("delete response----", res);
//       if (res.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         const butt = document.getElementById("getcancel");
//         butt.click();
//         dispatch(actionid("1"));
//         history.replace("/dashboard/CampaignControl");
//         Swal.fire({
//           icon: "success",
//           text: res.data.statusDescription.statusMessage,
//         });
//       } else if (res.data.statusDescription.statusCode == 228) {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // console.log(error);
//       setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   // .................................................................................................................//

//   // ...............................Download API On Download Button And Redirect................................................//

//   async function DownloadButtonApi(values) {
//     setDownloadLoader(true);

//     try {
//       // setOpen(true);
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/transactional/report`,
//         {
//           downloadReportRequest: {
//             queueCode: downloadModelOpen?.queue_code,
//             id: downloadModelOpen?.id,
//             reportType: "48 Hour",
//             username: localStorage.getItem("Username"),
//             campaignName: downloadModelOpen?.event_Name,
//           },
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         // setOpen(false);
//         LoaderApi();
//         // const butt = document.getElementById("Download-tab");
//         // butt.click();
//       } else {
//         // setData([])
//         setOpen(false);
//         setDownloadLoader(false);

//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       setDownloadLoader(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }
//   // ............................................................................................//
//   // ...............................DownloadTab API Redirect................................................//
//   // const [downloadData, setDownloadData] = useState([]);

//   // async function DownloadTabApi(values) {
//   //   setData([]);
//   //   try {
//   //     setOpen(true);
//   //     const result = await common_axios.post(
//   //       `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/get/v1/download/report`,

//   //      {
//   //       downloadReportRequest: {
//   //         reportType: "48 Hour",
//   //         pageNo: Status?.pageNo,
//   //         pageSize: Status?.pageSize,
//   //       }
//   //      }

//   //     );
//   //     // console.log("------resultssss", result);
//   //     if (result.data.statusDescription.statusCode == 200) {
//   //       setOpen(false);
//   //       // setData1(result.data?.downloadReport);
//   //       setDownloadData(result.data?.downloadReport);
//   //       // setData(result.data?.downloadReport?.content);
//   //     } else {
//   //       setOpen(false);
//   //       setData([]);
//   //       Swal.fire({
//   //         icon: "error",
//   //         title: "Oops...",
//   //         text: result.data.statusDescription.statusMessage,
//   //         // footer: '<a href="">Why do I have this issue?</a>'
//   //       });
//   //     }
//   //   } catch (error) {
//   //     setOpen(false);

//   //     Swal.fire({
//   //       icon: "error",
//   //       title: "Oops...",
//   //       text: "Please Check Your Network",
//   //       // footer: '<a href="">Why do I have this issue?</a>'
//   //     });
//   //   }
//   //   // console.log("response..", res);
//   // }

//   // useEffect(() => {
//   //   // if (Status?.approveType == "Download") {
//   //   DownloadTabApi();
//   //   // }
//   // }, [Status?.approveType]);
//   // useEffect(()=>{
//   //   DownloadTabApi();
//   // },[])
//   // ..................................................................................................................//
//   // ..........................................................................................................................//

//   const downloadFile = async (cell) => {
//     try {
//       const response = await common_axios.get(
//         `${cell?.row?.original?.download_Url}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             // UserId:`${localStorage.getItem('UserId')}`,
//             // Source: "web",
//           },
//         }
//       );

//       const url = window.URL.createObjectURL(
//         new Blob([response.data], { type: "application/vnd.ms-excel" })
//       );
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `excel-file.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//     } catch (error) {
//       // console.error(error);
//     }
//   };
//   // ................................................................................................................

//   const onKeyDown = (e) => {
//     e.preventDefault();
//   };

//   // ....................................Calaender DATE TIME........................................//

//   const datereff = useRef();

//   const [value, setValue] = React.useState(null);

//   useEffect(async () => {
//     if (Status.approveType != "Download") {
//       fetchUserr();
//     }
//   }, [Status.approveType, Status.pageSize, Status.pageNo]);

//   // ..........................................ScrollBar Useefffect................................//
//   useEffect(() => {
//     if (wrapper1Ref.current && wrapper2Ref.current) {
//       wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
//       wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
//     }
//     updateDivWidths();
//     window.addEventListener("resize", updateDivWidths);
//     return () => {
//       window.removeEventListener("resize", updateDivWidths);
//     };
//   }, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

//   // .....................................................................//

//   return (
//     <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//       <div className="container-fluid">
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//           // onClick={handleClose}
//         >
//           <Loader />
//         </Backdrop>
//         <div className="card mb-3 mt-4">
//           <div className="card-header p-3 pt-2">
//             <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
//               <PersonIcon
//                 style={{
//                   color: "white",
//                   fontSize: "27px",
//                 }}
//               />{" "}
//             </div>
//             <div style={{ marginLeft: "6rem" }}>
//               <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
//                 48HourReport
//               </p>
//             </div>
//           </div>

//           <div className="card-body">
//             <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link ms-4 active position-relative"
//                   id="home-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#AccountDetails"
//                   type="button"
//                   role="tab"
//                   aria-controls="AccountDetails"
//                   aria-selected="true"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       approveType: "Completed",
//                       pageNo: 0,
//                       pageSize: 10,
//                       hideShow: false,
//                       selectorType: null,
//                       resellerName: null,
//                       type: null,
//                     });
//                   }}
//                 >
//                   Completed
//                   <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
//                     {data2?.count?.completed == null
//                       ? 0
//                       : data2?.count?.completed}
//                   </span>
//                 </button>
//               </li>

//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link ms-4 position-relative"
//                   id="SenderMasking-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       approveType: "Stopped",
//                       pageNo: 0,
//                       pageSize: 10,
//                       hideShow: false,
//                       selectorType: null,
//                       resellerName: null,
//                       type: null,
//                     });
//                   }}
//                 >
//                   Stopped
//                   <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
//                     {data2?.count?.stopped == null ? 0 : data2?.count?.stopped}
//                   </span>
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link ms-4  position-relative"
//                   id="home-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#AccountDetails"
//                   type="button"
//                   role="tab"
//                   aria-controls="AccountDetails"
//                   aria-selected="true"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       approveType: "Dnd-Blacklist",
//                       pageNo: 0,
//                       pageSize: 10,
//                       hideShow: false,
//                       selectorType: null,
//                       resellerName: null,
//                       type: null,
//                     });
//                   }}
//                 >
//                   Blacklist/DND
//                   <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
//                     {data2?.count?.dndbLackList == null
//                       ? 0
//                       : data2?.count?.dndbLackList}
//                   </span>
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link ms-4  position-relative"
//                   id="failed-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#FailedDetails"
//                   type="button"
//                   role="tab"
//                   aria-controls="FailedDetails"
//                   aria-selected="true"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       approveType: "Failed",
//                       pageNo: 0,
//                       pageSize: 10,
//                       hideShow: false,
//                       selectorType: null,
//                       resellerName: null,
//                       type: null,
//                     });
//                   }}
//                 >
//                   Failed
//                   <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
//                     {data2?.count?.failed == null ? 0 : data2?.count?.failed}
//                   </span>
//                 </button>
//               </li>

//               {/* <li className="nav-item" role="presentation">
//                 <button
//                   className="nav-link ms-4  position-relative"
//                   id="Download-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#DownloadDetails"
//                   type="button"
//                   role="tab"
//                   aria-controls="DownloadDetails"
//                   aria-selected="true"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       approveType: "Download",
//                     });
//                     DownloadTabApi();
//                   }}
//                 >
//                   Download Report
//                   <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
//                     {downloadData?.totalElements == null
//                       ? 0
//                       : downloadData?.totalElements}
//                   </span>
//                 </button>
//               </li> */}
//             </ul>
//             {/* <div className="tab-content" id="myTabContent">
//               <div
             
//                 className={"tab-pane fade show "}
//                 id="DownloadDetails"
//                 role="tabpanel"
//                 aria-labelledby="AccountDetails-tab"
//               >
//                 <div>
//                   <DownloadData downloadData={downloadData} />
//                 </div>
//               </div>
//             </div> */}

//             {selectedUserDetail != undefined && (
//               <div>
//                 <button
//                   ref={modelButtonReject}
//                   type="button"
//                   className="btn btn-primary d-none"
//                   data-bs-toggle="modal"
//                   data-bs-target="#staticBackdrop"
//                 >
//                   Launch static backdrop modal
//                 </button>

//                 <div
//                   className="modal fade"
//                   id="staticBackdrop"
//                   data-bs-backdrop="static"
//                   data-bs-keyboard="false"
//                   tabindex="-1"
//                   aria-labelledby="staticBackdropLabel"
//                   aria-hidden="true"
//                 >
//                   <div className="modal-dialog">
//                     <div className="modal-content">
//                       <div className="modal-header">
//                         <h5 className="modal-title" id="staticBackdropLabel">
//                           ReSchedule Campaign
//                         </h5>
//                         <button
//                           type="button"
//                           className="btn-close"
//                           data-bs-dismiss="modal"
//                           aria-label="Close"
//                         ></button>
//                       </div>
//                       <div className="modal-body">
//                         <div className="col-md-5 my-2 upto_valid">
//                           {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
//                             <Stack spacing={3}>
//                               <DesktopDatePicker
//                                 disablePast
//                                 label="Valid Upto"
//                                 value={selectedUserDetail?.resheduledDateTime}
//                                 onChange={(newValue) => {
//                                   setSelectedUserDetail({
//                                     ...selectedUserDetail,
//                                     resheduledDateTime: moment(
//                                       newValue.$d
//                                     )?.format("YYYY-MM-DD HH:mm:ss"),
//                                   });
//                                 }}
//                                 renderInput={(params) => (
//                                   <TextField
//                                     onKeyDown={onKeyDown}
//                                     {...params}
//                                     helperText={"(Date time format mm/dd/yyyy"}
//                                     error={false}
//                                   />
//                                 )}
//                               />
//                             </Stack>
//                           </LocalizationProvider> */}
//                           <LocalizationProvider
//                             dateAdapter={AdapterDayjs}
//                             style={{ zIndex: "10px" }}
//                             // inputRef={datereff}
//                           >
//                             <DateTimePicker
//                               // disablePast
//                               // onError={(e) => {
//                               //   if (e) {
//                               //     setbuttonDisable(true);
//                               //   } else {
//                               //     setbuttonDisable(false);
//                               //   }
//                               // }}
//                               inputRef={datereff}
//                               minDate={dayjs(new Date())}
//                               renderInput={(props) => (
//                                 <TextField
//                                   size="small"
//                                   // required
//                                   error={false}
//                                   // onError={false}
//                                   style={{ zIndex: "10px" }}
//                                   {...props}
//                                   helperText={
//                                     "(Date time should be mm/dd/yyyy hh:mm)"
//                                   }
//                                 />
//                               )}
//                               ampm={false}
//                               style={{ zIndex: "10px" }}
//                               label="Select Schedule"
//                               // value={value}

//                               value={selectedUserDetail?.datetime_Scheduled}
//                               onChange={(newValue) => {
//                                 // console.log({newValue})
//                                 setSelectedUserDetail({
//                                   ...selectedUserDetail,
//                                   datetime_Scheduled: moment(
//                                     newValue.$d
//                                   )?.format("YYYY-MM-DD HH:mm:ss"),
//                                 });
//                               }}
//                               // onChange={(newValue) => {
//                               //   setValue(newValue);
//                               // }}
//                             />
//                           </LocalizationProvider>
//                         </div>
//                       </div>
//                       <div className="modal-footer mt-3 justify-content-between align-items-center">
//                         <button
//                           type="button"
//                           className="btn btn-secondary m-0"
//                           data-bs-dismiss="modal"
//                           id="getcancel"
//                           onClick={() => {
//                             setSelectedUserDetail(undefined);
//                           }}
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           // disabled={userEditState?.length == 0}
//                           type="submit"
//                           className="btn btn-primary editcolor m-0"
//                           onClick={ScheduleApi}
//                           // data-bs-dismiss="modal"
//                         >
//                           ReSchedule
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//             {selectedUserDetailApprove != undefined && (
//               <div>
//                 <button
//                   ref={modelButtonApprove}
//                   type="button"
//                   className="btn btn-primary d-none"
//                   data-bs-toggle="modal"
//                   data-bs-target="#staticBackdrop1"
//                 >
//                   Launch static backdrop modal
//                 </button>

//                 <div
//                   className="modal fade"
//                   id="staticBackdrop1"
//                   data-bs-backdrop="static"
//                   data-bs-keyboard="false"
//                   tabindex="-1"
//                   aria-labelledby="staticBackdrop1Label"
//                   aria-hidden="true"
//                 >
//                   <div className="modal-dialog">
//                     <div className="modal-content">
//                       <div className="modal-header">
//                         <h5 className="modal-title" id="staticBackdrop1Label">
//                           Send
//                         </h5>
//                         <button
//                           type="button"
//                           className="btn-close"
//                           data-bs-dismiss="modal"
//                           aria-label="Close"
//                         ></button>
//                       </div>
//                       <div className="modal-body">
//                         <h4>User Information</h4>
//                         <h5>User ID:{selectedUserDetailApprove.id}</h5>
//                         <h5>User ID:{selectedUserDetailApprove.firstName}</h5>
//                         <h5>User ID:{selectedUserDetailApprove.role}</h5>
//                         <h5>User ID:{selectedUserDetailApprove.email}</h5>
//                       </div>
//                       {/* <div className="modal-footer">
//                         <button
//                           type="button"
//                           className="btn btn-secondary"
//                           data-bs-dismiss="modal"
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           data-bs-dismiss="modal"
//                           onClick={() => {
//                             approveUserModal();
//                           }}
//                         >
//                           Approve User
//                         </button>
//                       </div> */}

//                       <div className="modal-footer mt-3 justify-content-between align-items-center">
//                         <button
//                           type="button"
//                           className="btn btn-secondary m-0"
//                           data-bs-dismiss="modal"
//                           id="getcancel"
//                           onClick={() => {
//                             setSelectedUserDetailApprove(undefined);
//                           }}
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           // disabled={userEditState?.length == 0}
//                           type="submit"
//                           className="btn btn-primary editcolor m-0"

//                           // onClick={SendNowApi}
//                           // data-bs-dismiss="modal"
//                         >
//                           Update
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div>
//               <button
//                 // ref={modelButtonApprove}
//                 ref={modelButtonDownload}
//                 type="button"
//                 className="btn btn-primary d-none"
//                 data-bs-toggle="modal"
//                 data-bs-target="#staticBackdrop2"
//               >
//                 Launch static backdrop modal
//               </button>

//               <div
//                 className="modal fade"
//                 id="staticBackdrop2"
//                 data-bs-backdrop="static"
//                 data-bs-keyboard="false"
//                 tabindex="-1"
//                 aria-labelledby="staticBackdrop2Label"
//                 aria-hidden="true"
//               >
//                 <div className="modal-dialog ">
//                   <div className="modal-content">
//                     <div className="modal-header">
//                       <h5 className="modal-title" id="staticBackdrop2Label">
//                         Download Request
//                       </h5>
//                       <button
//                         type="button"
//                         className="btn-close"
//                         data-bs-dismiss="modal"
//                         aria-label="Close"
//                       ></button>
//                     </div>

//                     <div className="modal-body">
//                       {/* Are you sure you want to download the report ? */}
//                       Are you sure you want to initiate the download request ?
//                     </div>

//                     <div className="modal-footer justify-content-between">
//                       <button
//                         type="button"
//                         className="btn btn-secondary shadow"
//                         data-bs-dismiss="modal"
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         type="button"
//                         className="btn btn-primary editcolor shadow okbtn"
//                         data-bs-dismiss="modal"
//                         // onClick={() => {
//                         //   DownloadButtonApi
//                         // }}
//                         onClick={DownloadButtonApi}
//                       >
//                         Download Request
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {data?.length > 0 && Status?.approveType != "Download" ? (
//               <>
//                 <div className="d-flex justify-content-between mt-3">
//                   <div className="my-auto">
//                     <div className=" d-flex">
//                       <div className="my-auto">
//                         <select
//                           value={Status.pageSize}
//                           className="dropdown p-2"
//                           onChange={(e) => {
//                             setPageSize(Number(e.target.value));
//                             setStatus({
//                               ...Status,
//                               pageSize: e.target.value,
//                             });
//                           }}
//                         >
//                           {[10, 25, 50].map((value, i) => {
//                             return (
//                               <option
//                                 className="dropdown-menu"
//                                 aria-labelledby="dropdownMenuButton1"
//                                 value={value}
//                                 key={value}
//                               >
//                                 Show {value}
//                               </option>
//                             );
//                           })}
//                         </select>
//                       </div>

//                       <div className="my-auto mx-4">
//                         {Status?.approveType != "Download" && (
//                           <>
//                             <div className="" style={{ flexGrow: "1" }}>
//                               <IconButton
//                                 variant="text"
//                                 size="small"
//                                 sx={{
//                                   color: "#7B809A",
//                                 }}
//                                 onClick={(event) => {
//                                   setStatus({
//                                     ...Status,
//                                     hideShow: !Status.hideShow,
//                                   });
//                                 }}
//                               >
//                                 {Status.hideShow ? (
//                                   <CancelIcon />
//                                 ) : (
//                                   <SearchIcon />
//                                 )}
//                               </IconButton>
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     className=""
//                     style={{ minHeight: "4rem", maxHeight: "4rem" }}
//                   >
//                     <div className="d-flex flex-wrap justify-content-between my-3">
//                       {Status?.hideShow && (
//                         <>
//                           <div
//                             className="d-flex me-3"
//                             style={{ width: "200px" }}
//                           >
//                             <FormControl fullWidth>
//                               <InputLabel size="small" id="test-select-label">
//                                 Select Search Category
//                               </InputLabel>
//                               <Select
//                                 size="small"
//                                 labelId="demo-simple-select-label"
//                                 id="demo-simple-select"
//                                 value={Status.selectorType}
//                                 label="Select Search Category"
//                                 onChange={(e) => {
//                                   setStatus({
//                                     ...Status,
//                                     selectorType: e.target.value,
//                                     resellerName: "",
//                                     type: null,
//                                   });
//                                 }}
//                               >
//                                 {[
//                                   {
//                                     id: 0,
//                                     name: "Campaign Name",
//                                     value: "Event Name",
//                                   },

//                                   {
//                                     id: 2,
//                                     name: "Type",
//                                     value: "Type",
//                                   },
//                                 ].map((d) => {
//                                   return (
//                                     <MenuItem key={d.id} value={d.value}>
//                                       {" "}
//                                       {d.name}
//                                     </MenuItem>
//                                   );
//                                 })}
//                               </Select>
//                             </FormControl>
//                           </div>

//                           <div className="d-flex">
//                             {Status.selectorType == "Event Name" ? (
//                               <TextField
//                                 required
//                                 className="w-100 me-3"
//                                 label="Campaign Name"
//                                 name="senderId"
//                                 variant="outlined"
//                                 size="small"
//                                 type="text"
//                                 value={Status.resellerName}
//                                 onChange={(e) => {
//                                   setStatus({
//                                     ...Status,

//                                     resellerName: e.target.value,
//                                   });
//                                 }}
//                               />
//                             ) : null}

//                             {Status.selectorType == "Type" ? (
//                               <div
//                                 className="d-flex justify-content-between mx-3"
//                                 style={{ width: "200px" }}
//                               >
//                                 <FormControl fullWidth>
//                                   <InputLabel
//                                     size="small"
//                                     id="test-select-label"
//                                   >
//                                     Select Type
//                                   </InputLabel>
//                                   <Select
//                                     size="small"
//                                     labelId="demo-simple-select-label"
//                                     id="demo-simple-select"
//                                     value={Status.type}
//                                     label="Select Type"
//                                     onChange={(e) => {
//                                       setStatus({
//                                         ...Status,

//                                         type: e.target.value,
//                                       });
//                                     }}
//                                   >
//                                     {[
//                                       { id: 0, name: "All", value: null },
//                                       {
//                                         id: 1,
//                                         name: "Promotional",
//                                         value: "Promotional",
//                                       },
//                                       {
//                                         id: 2,
//                                         name: "Transactional",
//                                         value: "Transactional",
//                                       },
//                                     ].map((d) => {
//                                       return (
//                                         <MenuItem value={d.value}>
//                                           {" "}
//                                           {d.name}
//                                         </MenuItem>
//                                       );
//                                     })}
//                                   </Select>
//                                 </FormControl>
//                               </div>
//                             ) : null}
//                             <div className="d-flex justify-content-between">
//                               <button
//                                 disabled={
//                                   Status.type == null &&
//                                   (Status.resellerName == null ||
//                                     Status.resellerName == "")
//                                 }
//                                 onClick={fetchUserr}
//                                 className={
//                                   Status.type == null &&
//                                   (Status.resellerName == null ||
//                                     Status.resellerName == "")
//                                     ? "btn btn-secondary"
//                                     : "btn btn-primary"
//                                 }
//                               >
//                                 <FilterAltIcon />
//                               </button>
//                             </div>
//                             <div className="d-flex justify-content-between ms-3">
//                               <button
//                                 onClick={() => {
//                                   setStatus({
//                                     ...Status,
//                                     selectorType: null,
//                                     resellerName: "",
//                                     type: null,
//                                   });
//                                 }}
//                                 className="btn btn-primary"
//                               >
//                                 Reset
//                               </button>
//                             </div>
//                           </div>
//                         </>
//                       )}
//                       {/* {Status?.approveType != "Download" && (
//                 <> */}
//                       {/* <div className="text-end" style={{ flexGrow: "1" }}>
//                     <IconButton
//                       variant="text"
//                       size="small"
//                       sx={{
//                         color: "#7B809A",
//                       }}
//                       onClick={(event) => {
//                         setStatus({
//                           ...Status,
//                           hideShow: !Status.hideShow,
//                         });
//                       }}
//                     >
//                       {Status.hideShow ? <CancelIcon /> : <SearchIcon />}
//                     </IconButton>
//                   </div> */}
//                       {/* </>
//               )} */}
//                     </div>
//                   </div>

//                   <div className="my-auto">
//                     <Tooltip title="Refresh">
//                       <button
//                         type="submit"
//                         className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
//                         // onClick={RefreshBtn}
//                         onClick={() => RefreshBtn("Text to Copy")}
//                       >
//                         {/* <i class="material-icons opacity-10">refresh</i> */}
//                         <RefreshIcon />
//                       </button>
//                     </Tooltip>
//                   </div>

//                   {/* <TextField
//                         className="ms-4"
//                         style={{
//                           borderRadius: "4px",
//                         }}
//                         type="text"
//                         label="Search"
//                         name="Search"
//                         variant="outlined"
//                         // value={number}
//                         size="small"
//                         value={globalSearchValue || ""}
//                         onChange={(e) => {
//                           onChange(e.target.value);
//                           setGlobalSearchValue(e.target.value);
//                         }}
//                       /> */}
//                 </div>

//                 {/* <div className="d-flex justify-content-between my-3"> */}

//                 {/* <TextField
//                         className="ms-4"
//                         style={{
//                           borderRadius: "4px",
//                         }}
//                         type="text"
//                         label="Search"
//                         name="Search"
//                         variant="outlined"
//                         // value={number}
//                         size="small"
//                         value={globalSearchValue || ""}
//                         onChange={(e) => {
//                           onChange(e.target.value);
//                           setGlobalSearchValue(e.target.value);
//                         }}
//                       /> */}
//                 {/* </div> */}
//                 <div className="text-end">
//                   {selectedFlatRows.length > 0 && (
//                     <button
//                       onClick={deletUser}
//                       className="btn bg-gradient-primary m-0"
//                     >
//                       Delete Users
//                     </button>
//                   )}
//                 </div>

//                 <div className="table-responsive mt-4">
//                   <>
//                     {/* <div class="wrapper1" ref={wrapper1Ref}>
//                     <div class="div1" style={{visibility:"hidden"}}ref={div1Ref}>
//                       <table
//                         {...getTableProps()}
//                         id="example"
//                         class="w-100 table table-striped table-bordered message_table table-sm dataTable no-footer m-0"
//                         // className="table table-striped message_table table-bordered dataTable table-sm mt-3"
//                         style={{ width: "100%" }}
//                       >
//                         <thead className="teble_scroll2">
//                           {headerGroups.map((headerGroup) => (
//                             <tr {...headerGroup.getHeaderGroupProps()}>
//                               {headerGroup.headers.map((column) => (
//                                 <th
//                                   {...column.getHeaderProps(
//                                     column.getSortByToggleProps()
//                                   )}
//                                   className="text-center width_2 update_th"
//                                 >
//                                   {column.render("Header")}
//                                   <span>
//                                     {column.isSorted
//                                       ? column.isSortedDesc
//                                         ? "↑"
//                                         : "↓"
//                                       : ""}
//                                   </span>
//                                 </th>
//                               ))}
//                             </tr>
//                           ))}
//                         </thead>
//                         <tbody {...getTableBodyProps()}>
//                           {page.map((row) => {
//                             prepareRow(row);
//                             return (
//                               <tr {...row.getRowProps()}>
//                                 {row.cells.map((cell) => {
//                                   return (
//                                     <td
//                                       {...cell.getCellProps()}
//                                       //   className={
//                                       //   (cell.column.Header == "Sender Id" ||
//                                       //     cell.column.Header == "SMS count" ||
//                                       //     cell.column.Header == "Start Date" ||
//                                       //     cell.column.Header == "End Date" ) &&
//                                       //   "text-end"
//                                       // }

//                                       className={
//                                             cell.column.Header == "Sender Id" ||
//                                             cell.column.Header ==
//                                               "Total Sms"
//                                               ||
//                                             cell.column.Header ==
//                                               "Sms Success"
//                                               ||
//                                             cell.column.Header ==
//                                               "Sms Fail" 
                                             
//                                               ? "text-end update_td"
//                                               : cell.column.Header == "Status"||
//                                                 cell.column.Header == "Download"||
//                                                 cell.column.Header ==
//                                                   "Download" ||
//                                                 cell.column.Header ==
//                                                   "Id"
//                                                   ||
//                                                 cell.column.Header ==
//                                                   "Camp Type"
//                                               ? "text-center update_td"
//                                               : "text-start update_td"
//                                           }
//                                       // className="text-left"
//                                     >
//                                       {cell.render("Cell")}
//                                     </td>
//                                   );
//                                 })}
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   <div class="wrapper2" ref={wrapper2Ref}>
//                     <div class="div2" ref={div2Ref}> */}
//                     <table
//                       {...getTableProps()}
//                       id="example"
//                       class="w-100 table table-striped table-bordered message_table table-sm dataTable no-footer m-0"
//                       // className="table table-striped message_table table-bordered dataTable table-sm mt-3"
//                       style={{ width: "100%" }}
//                     >
//                       <thead>
//                         {headerGroups.map((headerGroup) => (
//                           <tr {...headerGroup.getHeaderGroupProps()}>
//                             {headerGroup.headers.map((column) => (
//                               <th
//                                 {...column.getHeaderProps(
//                                   column.getSortByToggleProps()
//                                 )}
//                                 className={
//                                   column?.Header == "Message"
//                                     ? "text-center width_2 update_th messageWidth"
//                                     : column?.Header == "Camp Type"
//                                     ? "text-center width_2 update_th_sp d-flex border-start-0"
//                                     : "text-center width_2 update_th_sp border-start-0"
//                                 }
//                               >
//                                 {column.render("Header")}
//                                 <span>
//                                   {column.isSorted
//                                     ? column.isSortedDesc
//                                       ? "↑"
//                                       : "↓"
//                                     : ""}
//                                 </span>
//                                 {column.Header == "Camp Type" ? (
//                                   <>
//                                     <InputAdornment
//                                       position="end"
//                                       className="my-auto"
//                                     >
//                                       <Tooltip
//                                         title={"P-Promotional T-Transactional"
//                                           .split(" ")
//                                           .map((arg) => {
//                                             return (
//                                               <>
//                                                 {arg}
//                                                 <br />
//                                               </>
//                                             );
//                                           })}
//                                         placement="top"
//                                         arrow
//                                         sx={{ color: "white" }}
//                                       >
//                                         <InfoIcon />
//                                       </Tooltip>
//                                     </InputAdornment>
//                                   </>
//                                 ) : (
//                                   <></>
//                                 )}
//                               </th>
//                             ))}
//                           </tr>
//                         ))}
//                       </thead>
//                       <tbody {...getTableBodyProps()}>
//                         {page.map((row) => {
//                           prepareRow(row);
//                           return (
//                             <tr {...row.getRowProps()}>
//                               {row.cells.map((cell) => {
//                                 return (
//                                   <td
//                                     {...cell.getCellProps()}
//                                     //   className={
//                                     //   (cell.column.Header == "Sender Id" ||
//                                     //     cell.column.Header == "SMS count" ||
//                                     //     cell.column.Header == "Start Date" ||
//                                     //     cell.column.Header == "End Date" ) &&
//                                     //   "text-end"
//                                     // }

//                                     className={
//                                       cell.column.Header == "Sender Id" ||
//                                       cell.column.Header == "Total Sms" ||
//                                       cell.column.Header == "Sms Success" ||
//                                       cell.column.Header == "Sms Fail"
//                                         ? "text-end update_td"
//                                         : cell.column.Header == "Status" ||
//                                           cell.column.Header == "Download" ||
//                                           cell.column.Header == "Download" ||
//                                           cell.column.Header == "Id" ||
//                                           cell.column.Header == "Camp Type"
//                                         ? "text-center update_td"
//                                         : "text-start update_td"
//                                     }
//                                     // className="text-left"
//                                   >
//                                     {cell.render("Cell")}
//                                   </td>
//                                 );
//                               })}
//                             </tr>
//                           );
//                         })}
//                       </tbody>
//                     </table>
//                     {/* </div>
//                   </div> */}
//                   </>
//                 </div>
//                 <div className="d-flex justify-content-between mt-3">
//                   <div>
//                     <span>
//                       Page:
//                       <strong>
//                         {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
//                       </strong>
//                     </span>
//                   </div>

//                   {/* <div>
//                     <span>
//                       Go to Page :
//                       <input
//                         type="number"
//                         // defaultValue={pageIndex + 1}
//                         // value={data1?.pageable?.pageNumber + 1}
//                         value={Status?.pageNo + 1}
//                         onChange={(e) => {
//                           if (
//                             e.target.value > 0 &&
//                             e.target.value < data1?.totalPages + 1
//                           ) {
//                             const pageNumber = e.target.value
//                               ? Number(e.target.value) - 1
//                               : 0;
//                             setStatus({
//                               ...Status,
//                               pageNo: pageNumber,
//                             });
//                           }
//                         }}
//                         style={{ width: "50px" }}
//                       />
//                     </span>
//                   </div> */}

//                   <div>
//                     <button
//                       className="btn btn_primary "
//                       type="button"
//                       style={{ background: "#2C97D4" }}
//                       disabled={data1?.pageable?.pageNumber == 0}
//                       onClick={() => {
//                         setStatus({
//                           ...Status,
//                           pageNo: Status.pageNo - 1,
//                         });
//                       }}
//                     >
//                       Prev
//                     </button>

//                     <button
//                       className="btn btn_primary ms-2"
//                       type="button"
//                       style={{ background: "#2C97D4" }}
//                       disabled={
//                         data1?.totalPages == data1?.pageable?.pageNumber + 1
//                       }
//                       onClick={() => {
//                         setStatus({
//                           ...Status,
//                           pageNo: Status.pageNo + 1,
//                         });
//                       }}
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <div className="text-center mt-4">
//                 {(data?.length == 0 && open) ||
//                 Status?.approveType == "Download" ? null : (
//                   <div className="text-center">
//                     <h5>No Record Found..!!</h5>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }














import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { common_axios } from "../../../../App";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import * as React from "react";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { actionid } from "../../../../redux/features/pageSlices";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
// import "./Progress.css";
// import TextField from "@mui/material/TextField";
import ProgressLoader from "../DeliveryReports/ProgressLoader";
// import TextField from "@mui/material/TextField";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Tooltip } from "@mui/material";
import DownloadData from "./DownloadData";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
import InfoIcon from "@mui/icons-material/Info";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Pagination from "@mui/material/Pagination";
import { useSelector } from "react-redux";
import {Stack,} from "@mui/material";
import Fab from "@mui/material/Fab";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%" }} className="mx-auto">
        <LinearProgress
          //   color="green"className="mt-1"
          className="mt-1"
          sx={{
            "& .MuiLinearProgress-bar1Determinate": {
              backgroundColor: props.colorr,
            },
          }}
          variant="determinate"
          {...props}
        />
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
  color: PropTypes.number.isRequired,
};

export default function FortyEightHourReport() {
  const [open, setOpen] = useState();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [dataDownload, setDataDownload] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);

  const [data2, setData2] = useState([]);
  // console.log("first", data2);
  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries1
  );
  const [Status, setStatus] = useState({
    approveType: selectedTime?.approveType
      ? selectedTime?.approveType
      : "Completed",
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
    selectorType: null,
  });  const [apiNotHit, setApiNotHit] = useState(false);
  const [paginationPage, setPaginationPage] = React.useState(1);

  const [FilterStatus, setFilterStatus] = useState({
    filterpageNo: 0,
    filterpageSize: 10,
  });
  // .....................................................Scroll Bar.................................................................//

  const wrapper1Ref = useRef(null);
  const wrapper2Ref = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);

  const handleWrapper1Scroll = (e) => {
    wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
  };

  const handleWrapper2Scroll = (e) => {
    wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
  };

  const updateDivWidths = () => {
    // if (div1Ref.current && div2Ref.current) {
    //   div1Ref.current.style.width =
    //     div2Ref.current.querySelector("table").offsetWidth + "px";
    //   div2Ref.current.style.width =
    //     div2Ref.current.querySelector("table").offsetWidth + "px";
    // }
  };

  // ..................................................End Of Scroll Bar..............................................................//

  const history = useHistory();
  const dispatch = useDispatch();
  const [refreshButtonState, setRefreshButtonState] = useState(false);

  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);

  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };
  const [buttonDisable, setbuttonDisable] = useState(false);

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  // ......................Download Modal Open//////////////////////////////////////////////

  const [downloadModelOpen, setDownloadModel] = useState(undefined);
   console.log("first", refreshButtonState);
  const modelButtonDownload = useRef(null);
  const DownloadAction = async (cell) => {
    setDownloadModel(cell.row.original);
    await modelButtonDownload.current.click();
  };

  // ..................................................................................//
  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = common_axios(
        `${
          process.env.REACT_APP_COMMON_API_DASHBOARD_API
        }/sms/campaign-report/v1/get/48-hour/count?Role=${
          JSON.parse(localStorage.getItem("Sidebaritems")).name
        }`
      );
      const res1 = common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/event-name`,
        {
          flag: Status?.approveType,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      await Promise.all([res, res1]).then((values) => {
        if (
          values?.[0]?.data?.statusDescription?.statusCode == 200 &&
          values?.[1]?.data?.statusDescription?.statusCode == 200
        ) {
          setData2({
            count: values?.[0]?.data?.smsCampaignCounts?.[0],
            eventNames: values?.[1]?.data?.eventName,
          });

          setOpen(false);
        } else {
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: values[0].data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      });
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // useEffect(async () => {
  //   fetchUser();
  // }, [Status.approveType]);

  const fetchUserr = async () => {
    if (Status?.resellerName || Status.type) {
      try {
        setOpen(true);

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/find/by/campaign/name`,
          {
            flag: Status?.approveType,
            eventName:
              Status.resellerName == ("" && null) ? null : Status.resellerName,
            pageNo: FilterStatus?.filterpageNo,
            pageSize: FilterStatus?.filterpageSize,
            // category: Status?.type,
            smsType: Status?.type=="All" ? ["Promotional","Transactional"]: [Status?.type] ,
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );
        if (res.data?.statusDescription?.statusCode == 200) {
          setData1(res.data?.playSmsOutgoingQueueData);
          setData(res.data?.playSmsOutgoingQueueData?.content);
          setRefreshButtonState(false);
          setApiNotHit(true)

          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
          setRefreshButtonState(true);
          setApiNotHit(true)

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      setData([]);
      try {
        setOpen(true);

        const res = common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/48-hour/campaign-data`,
          {
            flag: Status?.approveType,
            pageNo: Status?.pageNo,
            pageSize: Status?.pageSize,
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );

        let res1;

        if (!data2?.count) {
          res1 = common_axios(
            `${
              process.env.REACT_APP_COMMON_API_DASHBOARD_API
            }/sms/campaign-report/v1/get/48-hour/count?Role=${
              JSON.parse(localStorage.getItem("Sidebaritems")).name
            }`
          );
        }

        await Promise.allSettled(!data2?.count ? [res, res1] : [res]).then(
          (results) => {
            if (
              results?.[0]?.value?.data?.statusDescription?.statusCode == 200
            ) {
              setData1(results?.[0]?.value?.data?.playSmsOutgoingQueueData);
              setData(
                results?.[0]?.value?.data?.playSmsOutgoingQueueData?.content
              );
              setStatus({
                ...Status,
                hideShow: false,
    
              });
              for (
                let index = 0;
                index < results?.[0]?.value?.data?.playSmsOutgoingQueueData?.content?.length;
                index++
              ) {
                results[0].value.data.playSmsOutgoingQueueData.content[index][`Show`] = true;
                // arr.push(obj);
              }
            }

            if (
              results?.[1]?.value?.data?.statusDescription?.statusCode == 200
            ) {
              setData2({
                count: results?.[1]?.value?.data?.smsCampaignCounts?.[0],
                eventNames: [],
              });
              setStatus({
                ...Status,
                hideShow: false,
    
              });
            }

            if (
              results?.[0]?.value?.data?.statusDescription?.statusCode == 220
            ) {
              setData([]);

            }

            if (
              results?.[0]?.value?.data?.statusDescription?.statusCode != 200 &&
              results?.[0]?.value?.data?.statusDescription?.statusCode != 220 &&
              results?.[0]?.value?.data?.statusDescription?.statusCode
            ) {
              // await toast.error(results?.[1]?.value?.data?.statusDescription?.statusMessage, {
              //   theme: "colored",
              //   toastId: customId1,
              // });
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: results?.[0]?.value?.data.statusDescription.statusMessage,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }

            if (
              results?.[1]?.value?.data?.statusDescription?.statusCode != 200 &&
              results?.[1]?.value?.data?.statusDescription?.statusCode != 220 &&
              results?.[1]?.value?.data?.statusDescription?.statusCode
            ) {
              // await toast.error(results?.[1]?.value?.data?.statusDescription?.statusMessage, {
              //   theme: "colored",
              //   toastId: customId1,
              // });
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: results?.[1]?.value?.data.statusDescription.statusMessage,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }
            setOpen(false);
          }
        );
      } catch (error) {
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  // ...................................................Refresh Button Api............................................................//

  async function RefreshBtn(values) {
    setData([]);
    try {
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/48-hour/campaign-data`,
        {
          flag: Status?.approveType,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        setData1(res.data?.playSmsOutgoingQueueData);
        setData(res.data?.playSmsOutgoingQueueData?.content);
        for (
          let index = 0;
          index < res?.data?.playSmsOutgoingQueueData?.content?.length;
          index++
        ) {
          res.data.playSmsOutgoingQueueData.content[index][`Show`] = true;
          // arr.push(obj);
        }
        setOpen(false);
        setStatus({
          ...Status,
          resellerName: null,
          type: null,
          hideShow: false,
          selectorType: null,
        });
      } else if (res.data?.statusDescription?.statusCode == 220) {
        setData([]);
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  // ..................................................................................................................................//

  // ...................................................Refresh Button Api............................................................//

  async function LoaderApi(values) {
    // setData([])
    try {
      // setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/get/48-hour/campaign-data`,
        {
          flag: Status?.approveType,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        setData1(res.data?.playSmsOutgoingQueueData);
        setData(res.data?.playSmsOutgoingQueueData?.content);
        setDownloadLoader(false);

        // setOpen(false);
      } else if (res.data?.statusDescription?.statusCode == 220) {
        setData([]);
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        setDownloadLoader(false);

        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);

      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  // ...................................................................................................................................../

  useEffect(() => {
    if (
      Status.selectorType == null &&
      Status.resellerName == "" &&
      Status.type == null
    )
      fetchUserr();
  }, [Status.resellerName, Status.type, Status.selectorType]);

  useEffect(() => {
    setStatus({
      ...Status,
      resellerName: null,
    });
  }, [Status.approveType]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
        "ROLE_SUPER_ADMIN" && Status?.approveType == "Failed"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Campaign name",

              accessor: "event_Name",
              Cell: (cell) => {
                return (
                  <>
                    <Link
                      onClick={() => {
                        localStorage.setItem(
                          "dstQueCode",
                          `${cell.row.original.queue_code},${cell.row.original.id}`
                        );
                      }}
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bolder",
                      }}
                      to={`/dashboard/48HourReport/All`}
                    >
                      {cell.row.original.event_Name}
                    </Link>
                    <div className="my-2 fw-bold" style={{ color: "#959595" }}>
                      {`(${cell?.row?.original?.username})`}
                    </div>
                  </>
                );
              },
            },

            {
              Header: "Start Date Time",

              accessor: "datetime_Entry", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
              // },
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_Entry
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "End Date Time",

              accessor: "datetime_End", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_End
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Sender Id",

              accessor: "sender_Id", // accessor is the "key" in the data
            },
            {
              Header: "Total Sms",

              accessor: "sms_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Sms Success",

              accessor: "success_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.success_Count?.toLocaleString("en-US")}
                  </>
                );
              },
            },
            {
              Header: "Sms Fail",

              accessor: "fail_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Camp Type",

              accessor: "sms_Type", // accessor is the "key" in the data

              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.sms_Type == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Failed Reason",

              accessor: "status", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.scheduled_Status == 8 ? (
                      <div
                        className=""
                        // style={{ width: "71% !important" }}
                      >
                        {/* Message Pushed {"    "} */}
                        {cell?.row?.original?.status}
                      </div>
                    ) : (
                      <div
                        className="badge bg-success activated_1"
                        // style={{ width: "71% !important" }}
                      >
                        {/* {cell?.row?.original?.log} */}
                      </div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Message",
              accessor: "message", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.message.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.message?.slice(0, 60) + "..."
                            : cell.row.original.message}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.message}</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Download",
              Footer: "Download",
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.file_Status == 0 ||
                    (downloadModelOpen?.id === cell?.row?.original?.id &&
                      downloadLoader == 1) ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : cell?.row?.original?.file_Status == 1 ? (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="">
                        <button
                          type="button"
                          className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                          id="btn_Update"
                          style={{ width: "auto" }}
                          onClick={() => {
                            DownloadAction(cell);
                          }}
                          // disabled={DownloadDisable}
                        >
                          {/* Download Request */}
                          <DownloadingSharpIcon />
                        </button>
                      </div>
                    )}
                  </>
                );
              },
            },
          ]
        : JSON.parse(localStorage.getItem("Sidebaritems")).name ==
            "ROLE_USER" && Status?.approveType == "Failed"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Event name",

              accessor: "event_Name",
              Cell: (cell) => {
                return (
                  <Link
                    onClick={() => {
                      localStorage.setItem(
                        "dstQueCode",
                        `${cell.row.original.queue_code},${cell.row.original.id}`
                      );
                    }}
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bolder",
                    }}
                    to={`/dashboard/48HourReport/All`}
                  >
                    {cell.row.original.event_Name}
                  </Link>
                );
              },
            },

            {
              Header: "Start Date Time",

              accessor: "datetime_Entry", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
              // },
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_Entry
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "End Date Time",

              accessor: "datetime_End", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_End
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Sender Id",

              accessor: "sender_Id", // accessor is the "key" in the data
            },
            {
              Header: "Total Sms",

              accessor: "sms_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Sms Success",

              accessor: "success_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.success_Count?.toLocaleString("en-US")}
                  </>
                );
              },
            },
            {
              Header: "Sms Fail",

              accessor: "fail_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Camp Type",

              accessor: "sms_Type", // accessor is the "key" in the data

              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.sms_Type == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Message",
              accessor: "message", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.message.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.message?.slice(0, 60) + "..."
                            : cell.row.original.message}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.message}</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Action",
              accessor: "action",
              Cell: (cell) => (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="">
                    <ul>
                      <li>
                        <button
                          className="btn color_1 px-2"
                          type="button"
                          id=""
                          data-bs-toggle=""
                          aria-expanded="false"
                          onClick={() => {
                            rejectUserModal(cell);
                          }}
                        >
                          <ScheduleIcon />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              ),
              disableFilters: true,
            },
            {
              Header: "Download",
              Footer: "Download",
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.file_Status == 0 ||
                    (downloadModelOpen?.id === cell?.row?.original?.id &&
                      downloadLoader == 1) ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : cell?.row?.original?.file_Status == 1 ? (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="">
                        <button
                          type="button"
                          className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                          id="btn_Update"
                          style={{ width: "auto" }}
                          onClick={() => {
                            DownloadAction(cell);
                          }}
                          // disabled={DownloadDisable}
                        >
                          {/* Download Request */}
                          <DownloadingSharpIcon />
                        </button>
                      </div>
                    )}
                  </>
                );
              },
            },
          ]
        : JSON.parse(localStorage.getItem("Sidebaritems")).name ==
            "ROLE_SUPER_ADMIN" && Status?.approveType != "Failed"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Campaign name",

              accessor: "event_Name",
              Cell: (cell) => {
                return (
                  <>
                    <Link
                      onClick={() => {
                        localStorage.setItem(
                          "dstQueCode",
                          `${cell.row.original.queue_code},${cell.row.original.id}`
                        );
                      }}
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bolder",
                      }}
                      to={`/dashboard/48HourReport/All`}
                    >
                      {cell.row.original.event_Name}
                    </Link>
                    <div className="my-2 fw-bold" style={{ color: "#959595" }}>
                      {`(${cell?.row?.original?.username})`}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Start Date Time",

              accessor: "datetime_Entry", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_Entry
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "End Date Time",

              accessor: "datetime_End", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.datetimeEntry)}</>;
              // },
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_End
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Sender Id",
              accessor: "sender_Id", // accessor is the "key" in the data
            },
            {
              Header: "Total Sms",

              accessor: "sms_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Sms Success",

              accessor: "success_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.success_Count?.toLocaleString("en-US")}
                  </>
                );
              },
            },
            {
              Header: "Sms Fail",

              accessor: "fail_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Camp Type",

              accessor: "sms_Type", // accessor is the "key" in the data

              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.sms_Type == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },

            // {
            //   Header: "Download",
            //   Footer: "Download",
            //   // accessor: "downloadUrl",
            //   Cell: (cell) => (
            //     <div className="">
            //       <button
            //         className="btn color_1 px-2"
            //         type="button"
            //         id=""
            //         data-bs-toggle=""
            //         aria-expanded="false"
            //         onClick={() => {
            //           DownloadAction(cell);
            //         }}
            //       >
            //         <FileDownloadIcon />
            //       </button>
            //     </div>
            //   ),
            // },
            {
              Header: "Message",
              accessor: "message", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.message.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.message?.slice(0, 60) + "..."
                            : cell.row.original.message}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.message}</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Download",
              Footer: "Download",
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.file_Status == 0 ||
                    (downloadModelOpen?.id === cell?.row?.original?.id &&
                      downloadLoader == 1) ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : cell?.row?.original?.file_Status == 1 ? (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="">
                        <button
                          type="button"
                          className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                          id="btn_Update"
                          style={{ width: "auto" }}
                          onClick={() => {
                            DownloadAction(cell);
                          }}
                          // disabled={DownloadDisable}
                        >
                          {/* Download Request */}
                          <DownloadingSharpIcon />
                        </button>
                      </div>
                    )}
                  </>
                );
              },
            },
          ]
        : [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Campaign name",

              accessor: "event_Name",
              Cell: (cell) => {
                return (
                  <Link
                    onClick={() => {
                      localStorage.setItem(
                        "dstQueCode",
                        `${cell.row.original.queue_code},${cell.row.original.id}`
                      );
                    }}
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bolder",
                    }}
                    to={`/dashboard/48HourReport/All`}
                  >
                    {cell.row.original.event_Name}
                  </Link>
                );
              },
            },

            {
              Header: "Start Date Time",

              accessor: "datetime_Entry", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_Entry
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "End Date Time",

              accessor: "datetime_End", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_End
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Sender Id",

              accessor: "sender_Id", // accessor is the "key" in the data
            },

            {
              Header: "Total Sms",

              accessor: "sms_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.sms_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Sms Success",

              accessor: "success_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.success_Count?.toLocaleString("en-US")}
                  </>
                );
              },
            },
            {
              Header: "Sms Fail",

              accessor: "fail_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.fail_Count?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Camp Type",

              accessor: "sms_Type", // accessor is the "key" in the data

              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.sms_Type == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },
            // {
            //   Header: "Status",

            //   accessor: "scheduled_Status",
            //   Cell: (cell) => {
            //     return (
            //       <>
            //         {cell.row.original.scheduled_Status == 6 ? (
            //           <div className="badge bg-success activated_1">
            //             Completed
            //           </div>
            //         ) : cell.row.original.scheduled_Status == 7 ? (
            //           <div className="badge bg-warning activated_1">
            //             All numbers are in Blacklist/DND
            //           </div>
            //         ) : cell.row.original.scheduled_Status == 8 ? (
            //           <div className="badge bg-warning activated_1">Failed</div>
            //         ) : (
            //           <div className="badge bg-danger activated_1">Stopped</div>
            //         )}
            //       </>
            //     );
            //   },
            // },

            {
              Header: "Message",
              accessor: "message", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.message.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.message?.slice(0, 60) + "..."
                            : cell.row.original.message}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.message}</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Download",
              Footer: "Download",
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.file_Status == 0 ||
                    (downloadModelOpen?.id === cell?.row?.original?.id &&
                      downloadLoader == 1) ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : cell?.row?.original?.file_Status == 1 ? (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="">
                        <button
                          type="button"
                          className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                          id="btn_Update"
                          style={{ width: "auto" }}
                          onClick={() => {
                            DownloadAction(cell);
                          }}
                          // disabled={DownloadDisable}
                        >
                          {/* Download Request */}
                          <DownloadingSharpIcon />
                        </button>
                      </div>
                    )}
                  </>
                );
              },
            },
          ],

    [
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
        "ROLE_SUPER_ADMIN",
      Status?.approveType,
      downloadLoader,
      Status,
      data,
    ]
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const viewRefModal = useRef(null);

  const { globalFilter } = state;

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };
  // ............................................................................................//
  async function DownloadApi(cell) {
    try {
      window.location.href = `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/export/transactional/report/excel?queueCode=${cell?.row?.original?.queue_code}`;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }

  // .........................................Schedule Api........................//
  const ScheduleApi = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/re-scheduled/failed/campaign`,
        {
          queueCode: selectedUserDetail?.queue_code,

          resheduledDateTime: moment(
            selectedUserDetail?.datetime_Scheduled
          )?.format("YYYY-MM-DD HH:mm:ss"),
        }
      );
      // console.log("delete response----", res);
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        const butt = document.getElementById("getcancel");
        butt.click();
        dispatch(actionid("1"));
        history.replace("/dashboard/CampaignControl");
        Swal.fire({
          icon: "success",
          text: res.data.statusDescription.statusMessage,
        });
      } else if (res.data.statusDescription.statusCode == 228) {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  // .................................................................................................................//

  // ...............................Download API On Download Button And Redirect................................................//

  async function DownloadButtonApi(values) {
    setDownloadLoader(true);

    try {
      // setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/transactional/report`,
        {
          downloadReportRequest: {
            queueCode: downloadModelOpen?.queue_code,
            id: downloadModelOpen?.id,
            reportType: "48 Hour",
            username: localStorage.getItem("Username"),
            campaignName: downloadModelOpen?.event_Name,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        // setOpen(false);
        LoaderApi();
        // const butt = document.getElementById("Download-tab");
        // butt.click();
      } else {
        // setData([])
        setOpen(false);
        setDownloadLoader(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      setDownloadLoader(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }
  // ............................................................................................//
  // ...............................DownloadTab API Redirect................................................//
  // const [downloadData, setDownloadData] = useState([]);

  // async function DownloadTabApi(values) {
  //   setData([]);
  //   try {
  //     setOpen(true);
  //     const result = await common_axios.post(
  //       `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/get/v1/download/report`,

  //      {
  //       downloadReportRequest: {
  //         reportType: "48 Hour",
  //         pageNo: Status?.pageNo,
  //         pageSize: Status?.pageSize,
  //       }
  //      }

  //     );
  //     // console.log("------resultssss", result);
  //     if (result.data.statusDescription.statusCode == 200) {
  //       setOpen(false);
  //       // setData1(result.data?.downloadReport);
  //       setDownloadData(result.data?.downloadReport);
  //       // setData(result.data?.downloadReport?.content);
  //     } else {
  //       setOpen(false);
  //       setData([]);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: result.data.statusDescription.statusMessage,
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   } catch (error) {
  //     setOpen(false);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Please Check Your Network",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   }
  //   // console.log("response..", res);
  // }

  // useEffect(() => {
  //   // if (Status?.approveType == "Download") {
  //   DownloadTabApi();
  //   // }
  // }, [Status?.approveType]);
  // useEffect(()=>{
  //   DownloadTabApi();
  // },[])
  // ..................................................................................................................//
  // ..........................................................................................................................//

  const downloadFile = async (cell) => {
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.download_Url}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            // UserId:`${localStorage.getItem('UserId')}`,
            // Source: "web",
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };
  // ................................................................................................................

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  // ....................................Calaender DATE TIME........................................//

  const datereff = useRef();

  const [value, setValue] = React.useState(null);

  useEffect(async () => {
    if (Status.approveType != "Download") {
      fetchUserr();
    }
  }, [Status.approveType, Status.pageSize, Status.pageNo]);

  // ..........................................ScrollBar Useefffect................................//
  useEffect(() => {
    if (wrapper1Ref.current && wrapper2Ref.current) {
      wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
      wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
    }
    updateDivWidths();
    window.addEventListener("resize", updateDivWidths);
    return () => {
      window.removeEventListener("resize", updateDivWidths);
    };
  }, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

  // .....................................................................//
  useEffect(() => {
    if (Status?.resellerName == "" && apiNotHit == true) {
     fetchUserr();
   }
 }, [Status?.resellerName]);


 const [showFab, setShowFab] = useState(true);
 const [showFabLeft, setShowFabLeft] = useState(true);
 console.log("kks",showFab)
 const handleScrollRight = () => {
   const table = document.getElementById("tableTarget"); // Replace 'myTable' with the actual ID of your table
   if (table) {
     const nextScrollLeft = table.scrollLeft + 500; // Adjust the scroll amount as needed
     // setShowFab(nextScrollLeft < table.scrollWidth - table.clientWidth);
     // setShowFab(false);
     // setShowFabLeft(true);
     table.scroll({
       left: nextScrollLeft,
       behavior: "smooth",
     });
   }
 };
 const handleScroll = () => {
   const table = document.getElementById("tableTarget");
   if (table) {
     if (
       Math.round(table.scrollLeft) <
       table.scrollWidth - table.clientWidth
     ) {
       // setShowFab(true);
       // setShowFabLeft(false);
 
     } else if (
       Math.round(table.scrollLeft) ==
       table.scrollWidth - table.clientWidth
     ) {
       // setShowFab(false);
       // setShowFabLeft(true);
 
     }
   }
 };
 
 
 useEffect(()=>{
   handleScroll();
 },[])
 
 
 const handleScrollLeft = () => {
   const table = document.getElementById("tableTarget"); // Replace 'myTable' with the actual ID of your table
   if (table) {
     const nextScrollRight = table.scrollRight + 500; // Adjust the scroll amount as needed
     // setShowFab(nextScrollLeft < table.scrollWidth - table.clientWidth);
     // setShowFabLeft(false);
     // setShowFab(true)
     table.scroll({
       left: nextScrollRight,
       behavior: "smooth",
     });
   }
 };
 
 const handleScroll1 = () => {
   const table = document.getElementById("tableTarget");
   if (table) {
     // console.log(
     //   "tablescroll",
     //   Math.round(table.scrollLeft),
     //   table.scrollWidth - table.clientWidth
     // );
     if (
       Math.round(table.scrollRight) <
       table.scrollWidth - table.clientWidth
     ) {
       // setShowFab(false)
       // setShowFabLeft(true);
     } else if (
       Math.round(table.scrollRight) ==
       table.scrollWidth - table.clientWidth
     ) {
       // setShowFab(false)
       // setShowFabLeft(false);
     }
   }
 };
 useEffect(()=>{
   handleScroll1();
 },[])
 

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />{" "}
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                48HourReport
              </p>
            </div>
          </div>

          <div className="card-body">
            <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  // className="nav-link ms-4 active position-relative"
                  className={
                    Status.approveType == "Completed"
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "Completed",
                      pageNo: 0,
                      pageSize: 10,
                      hideShow: false,
                      selectorType: null,
                      resellerName: null,
                      type: null,
                    });
                    setRefreshButtonState(false)
                    setApiNotHit(false)

                  }}
                >
                  Completed
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    {data2?.count?.completed == null
                      ? 0
                      : data2?.count?.completed}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  // className="nav-link ms-4 position-relative"
                  className={
                    Status.approveType == "Stopped"
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "Stopped",
                      pageNo: 0,
                      pageSize: 10,
                      hideShow: false,
                      selectorType: null,
                      resellerName: null,
                      type: null,
                    });
                    setRefreshButtonState(false)
                    setApiNotHit(false)

                  }}
                >
                  Stopped
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {data2?.count?.stopped == null ? 0 : data2?.count?.stopped}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  // className="nav-link ms-4  position-relative"
                  className={
                    Status.approveType == "Dnd-Blacklist"
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "Dnd-Blacklist",
                      pageNo: 0,
                      pageSize: 10,
                      hideShow: false,
                      selectorType: null,
                      resellerName: null,
                      type: null,
                    });
                    setRefreshButtonState(false)
                    setApiNotHit(false)

                  }}
                >
                  Blacklist/DND
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                    {data2?.count?.dndbLackList == null
                      ? 0
                      : data2?.count?.dndbLackList}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  // className="nav-link ms-4  position-relative"
                  className={
                    Status.approveType == "Failed"
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="failed-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#FailedDetails"
                  type="button"
                  role="tab"
                  aria-controls="FailedDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "Failed",
                      pageNo: 0,
                      pageSize: 10,
                      hideShow: false,
                      selectorType: null,
                      resellerName: null,
                      type: null,
                    });
                    setRefreshButtonState(false)
                    setApiNotHit(false)

                  }}
                >
                  Failed
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
                    {data2?.count?.failed == null ? 0 : data2?.count?.failed}
                  </span>
                </button>
              </li>

              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4  position-relative"
                  id="Download-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#DownloadDetails"
                  type="button"
                  role="tab"
                  aria-controls="DownloadDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "Download",
                    });
                    DownloadTabApi();
                  }}
                >
                  Download Report
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
                    {downloadData?.totalElements == null
                      ? 0
                      : downloadData?.totalElements}
                  </span>
                </button>
              </li> */}
            </ul>
            {/* <div className="tab-content" id="myTabContent">
              <div
             
                className={"tab-pane fade show "}
                id="DownloadDetails"
                role="tabpanel"
                aria-labelledby="AccountDetails-tab"
              >
                <div>
                  <DownloadData downloadData={downloadData} />
                </div>
              </div>
            </div> */}

            {selectedUserDetail != undefined && (
              <div>
                <button
                  ref={modelButtonReject}
                  type="button"
                  className="btn btn-primary d-none"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  Launch static backdrop modal
                </button>

                <div
                  className="modal fade"
                  id="staticBackdrop"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                          ReSchedule Campaign
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="col-md-5 my-2 upto_valid">
                          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack spacing={3}>
                              <DesktopDatePicker
                                disablePast
                                label="Valid Upto"
                                value={selectedUserDetail?.resheduledDateTime}
                                onChange={(newValue) => {
                                  setSelectedUserDetail({
                                    ...selectedUserDetail,
                                    resheduledDateTime: moment(
                                      newValue.$d
                                    )?.format("YYYY-MM-DD HH:mm:ss"),
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    onKeyDown={onKeyDown}
                                    {...params}
                                    helperText={"(Date time format mm/dd/yyyy"}
                                    error={false}
                                  />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider> */}
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            style={{ zIndex: "10px" }}
                            // inputRef={datereff}
                          >
                            <DateTimePicker
                              // disablePast
                              // onError={(e) => {
                              //   if (e) {
                              //     setbuttonDisable(true);
                              //   } else {
                              //     setbuttonDisable(false);
                              //   }
                              // }}
                              inputRef={datereff}
                              minDate={dayjs(new Date())}
                              renderInput={(props) => (
                                <TextField
                                  size="small"
                                  // required
                                  error={false}
                                  // onError={false}
                                  style={{ zIndex: "10px" }}
                                  {...props}
                                  helperText={
                                    "(Date time should be mm/dd/yyyy hh:mm)"
                                  }
                                />
                              )}
                              ampm={false}
                              style={{ zIndex: "10px" }}
                              label="Select Schedule"
                              // value={value}

                              value={selectedUserDetail?.datetime_Scheduled}
                              onChange={(newValue) => {
                                // console.log({newValue})
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  datetime_Scheduled: moment(
                                    newValue.$d
                                  )?.format("YYYY-MM-DD HH:mm:ss"),
                                });
                              }}
                              // onChange={(newValue) => {
                              //   setValue(newValue);
                              // }}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                      <div className="modal-footer mt-3 justify-content-between align-items-center">
                        <button
                          type="button"
                          className="btn btn-secondary m-0"
                          data-bs-dismiss="modal"
                          id="getcancel"
                          onClick={() => {
                            setSelectedUserDetail(undefined);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          // disabled={userEditState?.length == 0}
                          type="submit"
                          className="btn btn-primary editcolor m-0"
                          onClick={ScheduleApi}
                          // data-bs-dismiss="modal"
                        >
                          ReSchedule
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {selectedUserDetailApprove != undefined && (
              <div>
                <button
                  ref={modelButtonApprove}
                  type="button"
                  className="btn btn-primary d-none"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop1"
                >
                  Launch static backdrop modal
                </button>

                <div
                  className="modal fade"
                  id="staticBackdrop1"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdrop1Label"
                  aria-hidden="true"
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdrop1Label">
                          Send
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <h4>User Information</h4>
                        <h5>User ID:{selectedUserDetailApprove.id}</h5>
                        <h5>User ID:{selectedUserDetailApprove.firstName}</h5>
                        <h5>User ID:{selectedUserDetailApprove.role}</h5>
                        <h5>User ID:{selectedUserDetailApprove.email}</h5>
                      </div>
                      {/* <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            approveUserModal();
                          }}
                        >
                          Approve User
                        </button>
                      </div> */}

                      <div className="modal-footer mt-3 justify-content-between align-items-center">
                        <button
                          type="button"
                          className="btn btn-secondary m-0"
                          data-bs-dismiss="modal"
                          id="getcancel"
                          onClick={() => {
                            setSelectedUserDetailApprove(undefined);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          // disabled={userEditState?.length == 0}
                          type="submit"
                          className="btn btn-primary editcolor m-0"

                          // onClick={SendNowApi}
                          // data-bs-dismiss="modal"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div>
              <button
                // ref={modelButtonApprove}
                ref={modelButtonDownload}
                type="button"
                className="btn btn-primary d-none"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop2"
              >
                Launch static backdrop modal
              </button>

              <div
                className="modal fade"
                id="staticBackdrop2"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-labelledby="staticBackdrop2Label"
                aria-hidden="true"
              >
                <div className="modal-dialog ">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdrop2Label">
                        Download Request
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      {/* Are you sure you want to download the report ? */}
                      Are you sure you want to initiate the download request ?
                    </div>

                    <div className="modal-footer justify-content-between">
                      <button
                        type="button"
                        className="btn btn-secondary shadow"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary editcolor shadow okbtn"
                        data-bs-dismiss="modal"
                        // onClick={() => {
                        //   DownloadButtonApi
                        // }}
                        onClick={DownloadButtonApi}
                      >
                        Download Request
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {data?.length > 0 && Status?.approveType != "Download" ? (
              <>
                <div className="d-flex justify-content-between mt-3">
                  <div className="my-auto">
                    <div className=" d-flex">
                      <div className="my-auto">
                        <select
                          value={Status.pageSize}
                          className="dropdown p-2"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setStatus({
                              ...Status,
                              pageSize: e.target.value,
                            });
                          }}
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="my-auto mx-4">
                        {Status?.approveType != "Download" && (
                          <>
                            <div className="" style={{ flexGrow: "1" }}>
                              <IconButton
                                variant="text"
                                size="small"
                                sx={{
                                  color: "#7B809A",
                                }}
                                onClick={(event) => {
                                  setStatus({
                                    ...Status,
                                    hideShow: !Status.hideShow,
                                    // resellerName: "",
                                    selectorType:null,
                                    type:null,

                                  });
                                  setApiNotHit(false)

                                }}
                              >
                                {Status.hideShow ? (
                                  <CancelIcon 
                                  />
                                ) : (
                                  <SearchIcon />
                                )}
                              </IconButton>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className=""
                    style={{ minHeight: "4rem", maxHeight: "4rem" }}
                  >
                    <div className="d-flex flex-wrap justify-content-between my-3">
                      {Status?.hideShow && (
                        <>
                          <div
                            className="d-flex me-3"
                            style={{ width: "200px" }}
                          >
                            <FormControl fullWidth>
                              <InputLabel size="small" id="test-select-label">
                                Select Search Category
                              </InputLabel>
                              <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={Status.selectorType}
                                label="Select Search Category"
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,
                                    selectorType: e.target.value,
                                    resellerName: "",
                                    type: null,
                                  });
                                }}
                              >
                                {[
                                  {
                                    id: 0,
                                    name: "Campaign Name",
                                    value: "Event Name",
                                  },

                                  {
                                    id: 2,
                                    name: "Type",
                                    value: "Type",
                                  },
                                ].map((d) => {
                                  return (
                                    <MenuItem key={d.id} value={d.value}>
                                      {" "}
                                      {d.name}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>

                          <div className="d-flex">
                            {Status.selectorType == "Event Name" ? (
                              <TextField
                                required
                                className="w-100 me-3"
                                label="Campaign Name"
                                name="senderId"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={Status.resellerName}
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,

                                    resellerName: e.target.value,
                                  });
                                }}
                              />
                            ) : null}

                            {Status.selectorType == "Type" ? (
                              <div
                                className="d-flex justify-content-between mx-3"
                                style={{ width: "200px" }}
                              >
                                <FormControl fullWidth>
                                  <InputLabel
                                    size="small"
                                    id="test-select-label"
                                  >
                                    Select Type
                                  </InputLabel>
                                  <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={Status.type}
                                    label="Select Type"
                                    onChange={(e) => {
                                      setStatus({
                                        ...Status,

                                        type: e.target.value,
                                      });
                                    }}
                                  >
                                    {[
                                      { id: 0, name: "All", value: "All" },
                                      {
                                        id: 1,
                                        name: "Promotional",
                                        value: "Promotional",
                                      },
                                      {
                                        id: 2,
                                        name: "Transactional",
                                        value: "Transactional",
                                      },
                                    ].map((d) => {
                                      return (
                                        <MenuItem value={d.value}>
                                          {" "}
                                          {d.name}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            ) : null}
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  Status.type == null &&
                                  (Status.resellerName == null ||
                                    Status.resellerName == "")
                                }
                                onClick={fetchUserr}
                                className={
                                  Status.type == null &&
                                  (Status.resellerName == null ||
                                    Status.resellerName == "")
                                    ? "btn btn-secondary"
                                    : "btn btn-primary"
                                }
                              >
                                <FilterAltIcon />
                              </button>
                            </div>
                            <div className="d-flex justify-content-between ms-3">
                              <button
                                onClick={() => {
                                  setStatus({
                                    ...Status,
                                    selectorType: null,
                                    resellerName: "",
                                    type: null,
                                  });
                                }}
                                className="btn btn-primary"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                      
                    </div>
                  </div>

                  <div className="my-auto">
                    <Tooltip title="Refresh">
                      <button
                        type="submit"
                        className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                        // onClick={RefreshBtn}
                        onClick={() => RefreshBtn("Text to Copy")}
                      >
                        {/* <i class="material-icons opacity-10">refresh</i> */}
                        <RefreshIcon />
                      </button>
                    </Tooltip>
                  </div>
                </div>

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>


                <div style={{position: "sticky",
    top: "0px",
    zIndex: "9"}}>
 <div class="d-flex justify-content-between" >
                    <div >
                        {showFabLeft && (
                    <Fab
                      // className="fab position-sticky"
                      onClick={handleScrollLeft}
                      // color="primary"
                      style={{
                        backgroundColor: "rgb(89 144 175)",
                        color: "white",
                        width:'31px',
                        height:'31px',
position:'sticky',
top:'0',
right:'0',
                        // marginTop: "46px"
                        
                      }}
                      // aria-label="add"
                    >
                      <ArrowLeftIcon style={{fontSize: "23px"}} />
                    </Fab>
                  )}
               </div>   
             <div>
                        {showFab && (
                    <Fab
                      // className="fab position-sticky"
                      onClick={handleScrollRight}
                      // color="primary"
                      style={{
                        backgroundColor: "rgb(89 144 175)",
                        color: "white",
                        position:'sticky',
                        top:'0',
                        right:'0',
                        width:'31px',
                        height:'31px',
                      }}
                      // aria-label="add"
                    >

  <ArrowRightIcon style={{fontSize: "23px"}}/>
                      {/* <PlayArrowIcon /> */}
                    </Fab>
                  )}
 </div>
                    </div>

                    </div>
                <div className="table-responsive mt-4" id="tableTarget" onScroll={(()=>{
 handleScroll();
handleScroll1()
                    })}>
                  <>
              
                    <table
                      {...getTableProps()}
                      id="example"
                      class="w-100 table table-striped table-bordered message_table table-sm dataTable no-footer m-0"
                      // className="table table-striped message_table table-bordered dataTable table-sm mt-3"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className={
                                  column?.Header == "Message"
                                    ? "text-center width_2 update_th messageWidth"
                                    : column?.Header == "Camp Type"
                                    ? "text-center width_2 update_th_sp d-flex border-start-0"
                                    : "text-center width_2 update_th_sp border-start-0"
                                }
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>
                                {column.Header == "Camp Type" ? (
                                  <>
                                    <InputAdornment
                                      position="end"
                                      className="my-auto"
                                    >
                                      <Tooltip
                                        title={"P-Promotional T-Transactional"
                                          .split(" ")
                                          .map((arg) => {
                                            return (
                                              <>
                                                {arg}
                                                <br />
                                              </>
                                            );
                                          })}
                                        placement="top"
                                        arrow
                                        sx={{ color: "white" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody  class='onhover_change' {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    //   className={
                                    //   (cell.column.Header == "Sender Id" ||
                                    //     cell.column.Header == "SMS count" ||
                                    //     cell.column.Header == "Start Date" ||
                                    //     cell.column.Header == "End Date" ) &&
                                    //   "text-end"
                                    // }

                                    className={
                                      cell.column.Header == "Sender Id" ||
                                      cell.column.Header == "Total Sms" ||
                                      cell.column.Header == "Sms Success" ||
                                      cell.column.Header == "Sms Fail"
                                        ? "text-end update_td"
                                        : cell.column.Header == "Status" ||
                                          cell.column.Header == "Download" ||
                                          cell.column.Header == "Download" ||
                                          cell.column.Header == "Id" ||
                                          cell.column.Header == "Camp Type"
                                        ? "text-center update_td"
                                        : "text-start update_td"
                                    }
                                    // className="text-left"
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {/* </div>
                  </div> */}
                  </>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>

              
                  <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setStatus({
                          ...Status,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setStatus({
                    ...Status,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setStatus({
                          ...Status,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>


                  {/* <div>
                    <button
                      className="btn btn_primary "
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo - 1,
                        });
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary ms-2"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={
                        data1?.totalPages == data1?.pageable?.pageNumber + 1
                      }
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo + 1,
                        });
                      }}
                    >
                      Next
                    </button>
                  </div> */}
                </div>
              </>
            ) : (
              <>
                <div className="row mt-2">
               

                  {refreshButtonState == true && (
                    <>
                    <div className="my-auto">
                    <div className=" d-flex">
                 
                      </div>
                  </div>

                      <div
                    className=""
                    style={{ minHeight: "4rem", maxHeight: "4rem" }}
                  >
                    <div className="d-flex flex-wrap justify-content-between my-3">
                    <div className="my-auto mx-4">
                        {Status?.approveType != "Download" && (
                          <>
                            <div className="" style={{ flexGrow: "1" }}>
                              <IconButton
                                variant="text"
                                size="small"
                                sx={{
                                  color: "#7B809A",
                                }}
                                onClick={(event) => {
                                  setStatus({
                                    ...Status,
                                    hideShow: !Status.hideShow,
                                    resellerName: "",
                                    selectorType:null,
                                  });
                                }}
                              >
                                {Status.hideShow ? (
                                  <CancelIcon />
                                ) : (
                                  <SearchIcon />
                                )}
                              </IconButton>
                            </div>
                          </>
                        )}
                      </div>
                    <div className="d-flex align-items-center">
                      {Status?.hideShow && (
                        <>
                        
                          <div
                            className="d-flex me-3"
                            style={{ width: "200px" }}
                          >
                              <FormControl fullWidth>
                              <InputLabel size="small" id="test-select-label">
                                Select Search Category
                              </InputLabel>
                              <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={Status.selectorType}
                                label="Select Search Category"
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,
                                    selectorType: e.target.value,
                                    resellerName: "",
                                    type: null,
                                  });
                                }}
                              >
                                {[
                                  {
                                    id: 0,
                                    name: "Campaign Name",
                                    value: "Event Name",
                                  },

                                  {
                                    id: 2,
                                    name: "Type",
                                    value: "Type",
                                  },
                                ].map((d) => {
                                  return (
                                    <MenuItem key={d.id} value={d.value}>
                                      {" "}
                                      {d.name}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>

                          <div className="d-flex">
                            {Status.selectorType == "Event Name" ? (
                              <TextField
                                required
                                className="w-100 me-3"
                                label="Campaign Name"
                                name="senderId"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={Status.resellerName}
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,

                                    resellerName: e.target.value,
                                  });
                                }}
                              />
                            ) : null}

                            {Status.selectorType == "Type" ? (
                              <div
                                className="d-flex justify-content-between mx-3"
                                style={{ width: "200px" }}
                              >
                                <FormControl fullWidth>
                                  <InputLabel
                                    size="small"
                                    id="test-select-label"
                                  >
                                    Select Type
                                  </InputLabel>
                                  <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={Status.type}
                                    label="Select Type"
                                    onChange={(e) => {
                                      setStatus({
                                        ...Status,

                                        type: e.target.value,
                                      });
                                    }}
                                  >
                                    {[
                                      { id: 0, name: "All", value: "All" },
                                      {
                                        id: 1,
                                        name: "Promotional",
                                        value: "Promotional",
                                      },
                                      {
                                        id: 2,
                                        name: "Transactional",
                                        value: "Transactional",
                                      },
                                    ].map((d) => {
                                      return (
                                        <MenuItem value={d.value}>
                                          {" "}
                                          {d.name}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            ) : null}

                      

                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  Status.type == null &&
                                  (Status.resellerName == null ||
                                    Status.resellerName == "") &&
                                  Status?.startTime == null
                                }
                                onClick={fetchUserr}
                                className={
                                  Status.type == null &&
                                  (Status.resellerName == null ||
                                    Status.resellerName == "") &&
                                  Status?.startTime == null
                                    ? "btn btn-secondary mb-0"
                                    : "btn btn-primary mb-0"
                                }
                              >
                                <FilterAltIcon />
                              </button>
                            </div>
                            <div className="d-flex justify-content-between ms-3">
                              <button
                                onClick={() => {
                                  setStatus({
                                    ...Status,
                                    selectorType: null,
                                    resellerName: "",
                                    type: null,
                                    startTime: null,
                                  });
                                }}
                                className="btn resetBtn_UP mb-0"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                      </div>
                      <Tooltip title="Refresh">
                          <button
                            type="submit"
                            className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                            onClick={() => RefreshBtn("Text to Copy")}
                          >
                            <RefreshIcon />
                          </button>
                        </Tooltip>
                   
                    </div>
                  </div>
                    
                    </>
                  )}
                  {(data?.length == 0 && open) ||
                  Status?.approveType == "Download" ? null : (
                    <div className="text-center mt-3">
                      <h5>No Record Found..!!</h5>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}




